<template>
  <el-dialog
    :visible.sync="isOpenInvoiceCreateDialog"
    :title="dialogTitle"
    width="80%"
    :before-close="handleClose"
    top="5vh"
    :close-on-click-modal="false"
    append-to-body
  >
    <div class="invoice-page">

      <!-- ================= TOP ================= -->

      <el-row :gutter="20" class="top-row-flex">

      <!-- ================= THÔNG TIN KHÁCH HÀNG ================= -->

      <el-col :span="12">

        <el-card class="box-card">

          <div slot="header" class="card-header">
            <span>THÔNG TIN KHÁCH HÀNG</span>
          </div>

          <el-form :model="form" :rules="rules" ref="customerForm" label-width="150px">
            <el-row :gutter="10">

              <el-col :span="12">
                <el-form-item>
                  <el-checkbox v-model="form.buyerNotGetInvoice">
                    Người mua không lấy hóa đơn
                  </el-checkbox>
                </el-form-item>
              </el-col>

              <el-col :span="12">
                <el-form-item>
                  <el-checkbox v-model="form.paymentStatus">Người mua đã thanh toán</el-checkbox>
                </el-form-item>
              </el-col>
            </el-row>

            <el-row :gutter="10">

              <el-col :span="15">
                  <el-form-item label="Tên người mua" prop="buyerName">
                    <el-input v-model="form.buyerName"/>
                  </el-form-item>
              </el-col>

              <el-col :span="9">
                <el-form-item label="Mã người mua">
                  <el-input v-model="form.buyerCode"/>
                </el-form-item>
              </el-col>

            </el-row>


            <el-form-item label="Địa chỉ" prop="buyerAddressLine" :required="true">
              <el-input v-model="form.buyerAddressLine"/>
            </el-form-item>


            <el-form-item label="Tên đơn vị" prop="buyerLegalName">
              <el-input v-model="form.buyerLegalName"/>
            </el-form-item>


            <el-row :gutter="10">

              <el-col :span="12">
                <el-form-item label="Mã số thuế" prop="buyerTaxCode">
                  <el-input v-model="form.buyerTaxCode"/>
                </el-form-item>
              </el-col>

              <el-col :span="12">
                <el-form-item label="Hợp đồng số">
                  <el-input v-model="form.contractNo"/>
                </el-form-item>
              </el-col>

            </el-row>


            <el-row :gutter="10">

              <el-col :span="12">
                <el-form-item label="Số điện thoại">
                  <el-input v-model="form.buyerPhoneNumber"/>
                </el-form-item>
              </el-col>

              <el-col :span="12">
                <el-form-item label="Email">
                  <el-input v-model="form.buyerEmail"/>
                </el-form-item>
              </el-col>

            </el-row>


            <el-row :gutter="10">

              <el-col :span="12">
                <el-form-item label="Loại giấy tờ">
                  <el-select v-model="form.buyerIdType" style="width:100%" clearable>
                    <el-option label="CCCD" value="1"/>
                    <el-option label= "Hộ chiếu" value="3"/>
                  </el-select>
                </el-form-item>
              </el-col>

              <el-col :span="12">
                <el-form-item label="Số giấy tờ" prop="buyerIdNo">
                  <el-input v-model="form.buyerIdNo"/>
                </el-form-item>
              </el-col>

            </el-row>


            <el-row :gutter="10">

              <el-col :span="12">
                <el-form-item label="Tên ngân hàng">
                  <el-input v-model="form.buyerBankName"/>
                </el-form-item>
              </el-col>

              <el-col :span="12">
                <el-form-item label="Số tài khoản">
                  <el-input v-model="form.buyerBankAccount"/>
                </el-form-item>
              </el-col>

            </el-row>

            <el-form-item label="Mã ĐVQH ngân sách">
              <el-input v-model="form.buyerBudgetCode"/>
            </el-form-item>
          </el-form>

        </el-card>

      </el-col>



      <!-- ================= THÔNG TIN HÓA ĐƠN ================= -->

      <el-col :span="12">

        <el-card class="box-card">

          <div slot="header" class="card-header">
            <span>THÔNG TIN HÓA ĐƠN</span>
          </div>

          <el-form :model="form" :rules="rules" ref="invoiceForm" label-width="150px">

<!--            <el-row :gutter="10">-->

<!--              <el-col :span="12">-->
<!--                <el-form-item label="Mã cửa hàng">-->
<!--                  <el-input v-model="form.storeCode"/>-->
<!--                </el-form-item>-->
<!--              </el-col>-->

<!--              <el-col :span="12">-->
<!--                <el-form-item label="Tên cửa hàng">-->
<!--                  <el-input v-model="form.storeName"/>-->
<!--                </el-form-item>-->
<!--              </el-col>-->

<!--            </el-row>-->


            <el-row :gutter="10">

              <!-- Hình thức thanh toán -->
              <el-col :span="12">
                <el-form-item label="Hình thức TT" prop="paymentMethod">
                  <el-select
                      v-model="form.paymentMethod"
                      style="width:100%"
                      @change="onPaymentMethodChange"
                  >
                    <el-option
                        v-for="item in paymentMethods"
                        :key="item.value"
                        :label="item.label"
                        :value="item.value"
                    />
                  </el-select>
                </el-form-item>
              </el-col>

              <!-- Chi tiết -->
              <el-col :span="12">
                <el-form-item label="Chi tiết hình thức" prop="paymentMethodName">
                  <el-input
                      v-model="form.paymentMethodName"
                      :disabled="form.paymentMethod !== '5'"
                      placeholder="Nhập hình thức thanh toán khác"
                  />
                </el-form-item>
              </el-col>

            </el-row>


            <el-row :gutter="10">

              <el-col :span="12">
                <el-form-item label="Loại tiền" prop="currencyCode">
                  <el-select v-model="form.currencyCode">
                    <el-option
                        v-for="item in currencyOptions"
                        :key="item"
                        :label="item"
                        :value="item"
                    />
                  </el-select>
                </el-form-item>
              </el-col>

              <el-col :span="12">
                <el-form-item label="Tỷ giá" prop="exchangeRate">
                  <el-input v-model="form.exchangeRate" :disabled="form.currencyCode ==='VND'"/>
                </el-form-item>
              </el-col>

            </el-row>


            <el-form-item label="Mẫu hóa đơn" prop="templateCode">
              <el-select v-model="form.templateCode" style="width:100%" @change="onInvoiceTemplateChange" filterable>
                <el-option
                    v-for="opt in invoiceTemplateOptions"
                    :key="opt.value"
                    :label="opt.label"
                    :value="opt.value"
                />
              </el-select>
            </el-form-item>


            <el-form-item label="Ký hiệu hóa đơn" prop="invoiceSeries">
              <el-select v-model="form.invoiceSeries" style="width:100%">
                <el-option
                    v-for="opt in invoiceSeriesOptions"
                    :key="opt.value"
                    :label="opt.label"
                    :value="opt.value"
                />
              </el-select>
            </el-form-item>


            <!-- Số bảng kê, Ngày bảng kê và upload Bảng kê đã bị loại bỏ theo yêu cầu -->


            <el-form-item label="Ngày lập" prop="invoiceDate">
              <el-date-picker
                  v-model="form.invoiceDate"
                  type="datetime"
                  style="width:100%"/>
            </el-form-item>

            <el-form-item label="Ghi chú">
              <el-input type="textarea" :rows="6" v-model="form.invoiceNote"/>

              <div class="invoice-warning">
                <div>1. Toàn bộ hóa đơn khi lưu nháp sẽ được lưu lại vào hệ thống bên phía OneKids để tiện cho việc chỉnh sửa sau này.</div>
              </div>
            </el-form-item>
          </el-form>

        </el-card>

      </el-col>

    </el-row>


    <!-- ================= CHI TIẾT HÓA ĐƠN ================= -->

    <el-card class="box-card mt20" v-if="form.templateCode !== ''">

      <div slot="header" class="card-header">
        <div class="invoice-detail-header">
          <span>CHI TIẾT HÓA ĐƠN</span>
          <el-switch
            v-model="enableGoodsTemplateSelection"
            active-text="Dùng hàng hóa, dịch vụ mẫu"
            @change="handleGoodsTemplateToggle"
          />
        </div>
      </div>

      <el-table border :data="items">

        <el-table-column label="STT" width="60" fixed>
          <template v-slot:default="{ row }">
            {{ computeVisibleIndex(row) }}
          </template>
        </el-table-column>

        <el-table-column label="Tính chất" width="250" fixed>
          <template v-slot:default="{ row }">
            <el-select v-model="row.selection" @change="onSelectionChange(row)">
              <el-option label="Hàng hóa, dịch vụ" :value="1"/>
              <el-option label="Ghi chú/diễn giải" :value="2"/>
              <el-option label="Chiết khấu" :value="3"/>
              <el-option label="Phí khác" :value="4"/>
              <el-option label="Khuyến mại" :value="5"/>
            </el-select>
          </template>
        </el-table-column>


        <!-- HÀNG HÓA -->

        <el-table-column label="Hàng hóa, dịch vụ" min-width="320" fixed>

          <template v-slot:default="{ row }">

            <div class="product-cell">

              <el-select
                  v-model="row.itemName"
                  @change="onProductChange(row)"
                  :disabled="!row.allowProduct"
                  filterable
                  allow-create
                  default-first-option
                  popper-class="product-option-popper"
                  :placeholder="getProductPlaceholder(row)"
                  style="width:100%"
              >

                <el-option
                    v-for="item in productOptions"
                    :key="item.code || item.name"
                    :label="item.name"
                    :value="item.name"
                >
                  <div class="product-option-wrap">
                    <div class="product-option-title">
                      {{ item.name }}
                    </div>
                    <div class="product-option-meta">
                      <template v-if="getProductOptionCode(item)">
                        Mã: {{ getProductOptionCode(item) }} -
                      </template>
                      Đơn giá: {{ formatProductOptionMeta(item) }}
                    </div>
                  </div>
                </el-option>

              </el-select>

            </div>

          </template>

        </el-table-column>



        <!-- ĐƠN VỊ -->

        <el-table-column label="Đơn vị tính" width="150">
            <template v-slot:default="{ row }">
            <el-select
                v-model="row.unitName"
                :disabled="!row.allowUnitName"
                filterable
                allow-create
                default-first-option
                placeholder="--Chọn đơn vị--"
                size="mini"
                style="width:100%"
                @change="onUnitNameChange(row)"
            >
              <el-option v-for="u in unitOptions" :key="u" :label="u" :value="u"/>
            </el-select>
          </template>
        </el-table-column>



        <!-- SỐ LƯỢNG -->

        <el-table-column width="150">
          <template v-slot:header> Số lượng <span class="required-asterisk">*</span> </template>
          <template v-slot:default="scope">
            <el-input
                v-model="scope.row.quantityDisplay"
                class="quantity-input"
                :disabled="!scope.row.allowQuantity"
                size="mini"
                placeholder="0"
                @blur="onQuantityBlur(scope.row)"
                @keyup.enter="onQuantityBlur(scope.row)"
            />
          </template>
        </el-table-column>



        <!-- ĐƠN GIÁ -->

        <el-table-column width="150">
          <template v-slot:header> Đơn giá <span class="required-asterisk">*</span> </template>
          <template v-slot:default="scope">
            <el-input
                v-model="scope.row.unitPriceDisplay"
                class="numeric-input"
                :disabled="!scope.row.allowUnitPrice"
                size="mini"
                placeholder="0"
                @blur="onUnitPriceBlur(scope.row)"
                @keyup.enter="onUnitPriceBlur(scope.row)"
            />
          </template>
        </el-table-column>



        <!-- THÀNH TIỀN -->

        <el-table-column width="160" align="right">
          <template v-slot:header> Thành tiền <span class="required-asterisk">*</span> </template>
          <template v-slot:default="scope">
            <el-input
                v-model="scope.row.itemTotalAmountWithoutTaxDisplay"
                class="numeric-input"
                :disabled="!scope.row.allowTotalAmount"
                size="mini"
                placeholder="0"
                @blur="onTotalAmountBlur(scope.row)"
                @keyup.enter="onTotalAmountBlur(scope.row)"
            />
          </template>
        </el-table-column>



        <!-- TIỀN THUẾ -->

        <el-table-column label="Tiền thuế" width="320">

          <template v-slot:default="{ row }">

            <div class="tax-cell">

              <!-- Select tax percentage -->
              <el-select
                  v-model="row.taxPercentage"
                  :disabled="!row.allowTax"
                  filterable
                  placeholder="--Lựa chọn--"
                  size="mini"
                  style="width:110px"
                  @change="onTaxPercentageChange(row)"
              >
                <el-option label="Khác" value="other"/>
                <el-option label="Không chịu thuế" :value="-2"/>
                <el-option label="Không kê khai" :value="-1"/>
                <el-option label="0%" :value="0"/>
                <el-option label="5%" :value="5"/>
                <el-option label="8%" :value="8"/>
                <el-option label="10%" :value="10"/>
              </el-select>

              <!-- Show compact input when CTTC or Khác selected -->
                <el-input
                    v-if="String(row.taxPercentage) === 'other'"
                    v-model="row.taxPercentageInput"
                    size="mini"
                    placeholder="%"
                    style="width:90px; margin-left:4px"
                    @blur="onCustomTaxInputBlur(row)"
                    @keyup.enter="onCustomTaxInputBlur(row)"
                />

              <span class="tax-equal">=</span>

              <span>{{ formatCurrency(row.taxAmount) }}</span>

            </div>

          </template>

        </el-table-column>



        <!-- GHI CHÚ -->

<!--        <el-table-column label="Ghi chú" min-width="200">-->

<!--            <template v-slot:default="{ row }">-->
<!--            <el-input v-model="row.itemNote"/>-->
<!--          </template>-->

<!--        </el-table-column>-->



        <!-- HÀNH ĐỘNG -->

        <el-table-column label="Hành động" width="120" align="center" fixed="right">

          <template v-slot:default="{ $index }">

            <el-button
                icon="el-icon-delete"
                type="danger"
                circle
                @click="removeRow($index)"
            />

          </template>

        </el-table-column>

      </el-table>


      <div class="add-row">

        <el-button
            type="danger"
            icon="el-icon-plus"
            @click="addRow">
          Thêm
        </el-button>

      </div>


      <!-- ================= TOTAL ================= -->

      <div class="invoice-total">

        <div class="row">
          <span>Tổng tiền hàng</span>
          <strong>{{ formatCurrency(subtotal) }}</strong>
        </div>

        <div class="row">
          <span>Tổng tiền trước thuế</span>
          <strong>{{ formatCurrency(totalBeforeTax) }}</strong>
        </div>

        <div class="row">
          <span>Tiền thuế</span>
          <strong>{{ formatCurrency(lineTaxTotal) }}</strong>
        </div>

        <div class="row">
          <span>Tổng tiền sau thuế</span>
          <strong>{{ formatCurrency(totalAfterTax) }}</strong>
        </div>

        <div class="row total">
          <span>Tổng tiền thanh toán</span>
          <strong>{{ formatCurrencyByCode(grandTotal, form.currencyCode) }}</strong>
        </div>

        <div class="row words">
          <span>Số tiền bằng chữ</span>
          <em>{{ totalInWordsCurrency }}</em>
        </div>

      </div>

    </el-card>


    </div>

    <span slot="footer" class="dialog-footer">
      <el-button @click="handleBack" type="danger">Quay lại</el-button>
      <el-button @click="handleClearInput" type="danger">Xóa dữ liệu nhập</el-button>
      <el-button :loading="actionLoading.preview" @click="handlePreviewInvoice" type="warning">Xem trước nháp</el-button>
      <el-button type="warning" :loading="actionLoading.draft" @click="handleSaveServerDraftInvoice" v-if="checkPermission(['electronic-invoice-create-draft'])">Lưu nháp</el-button>
      <el-button type="primary" :loading="actionLoading.final" @click="handleCreateInvoice" v-if="checkPermission(['electronic-invoice-create-issued']) && isCreateInvoice === true && getSinvoiceConfigField('usbDigitalSignature', false) === false">Phát hành HĐ</el-button>
    </span>

    <el-dialog
      title="Xem trước hóa đơn"
      :visible.sync="previewDialogVisible"
      width="90%"
      custom-class="preview-dialog-no-limit"
      append-to-body
      top="1vh"
      :before-close="handlePreviewDialogClose"
    >
      <div v-if="previewPdfUrl" class="preview-pdf-wrapper">
        <iframe :src="previewPdfUrl" class="preview-pdf-iframe"></iframe>
      </div>
      <div v-else>
        <pre class="preview-json">{{ previewPayloadText }}</pre>
      </div>
      <span slot="footer" class="dialog-footer">
         <el-button type="primary" :loading="actionLoading.save" @click="handleSaveServerDraftInvoice" v-if="checkPermission(['electronic-invoice-create-draft'])">Lưu nháp</el-button>
        <el-button type="danger" @click="previewDialogVisible = false">Đóng</el-button>
      </span>
    </el-dialog>
    <!-- Dialog xác nhận lập hóa đơn -->
    <el-dialog
        title="Xác nhận"
        :visible.sync="confirmIssueDialogVisible"
        width="420px"
        append-to-body
    >
      <div>Bạn có chắc chắn muốn lập hóa đơn không?</div>
      <span slot="footer" class="dialog-footer">
    <el-button @click="confirmIssueDialogVisible = false">Hủy</el-button>
    <el-button type="primary" @click="handleConfirmIssue">Đồng ý</el-button>
  </span>
    </el-dialog>

    <el-dialog
        title="Xác nhận"
        :visible.sync="confirmDraftDialogVisible"
        width="420px"
        append-to-body
    >
      <div>Bạn có chắc chắn muốn lập hóa đơn nháp không?</div>
      <span slot="footer" class="dialog-footer">
    <el-button @click="confirmDraftDialogVisible = false">Hủy</el-button>
    <el-button type="primary" :loading="actionLoading.draft" @click="handleConfirmCreateDraftInvoice">
      Đồng ý
    </el-button>
  </span>
    </el-dialog>

  </el-dialog>
</template>


<script>
import { ConvertMoneyToString } from '@/services/ConvertMoneyToString';
import SinvoiceViettelService from '@/services/SinvoiceViettelService';
import NotifyMessage from "@/commonFuncion/NotifyMessage";
import ElectronicInvoicesService from "@/services/ElectronicInvoicesService";
import sinvoiceConfigMixin from "@/global/mixin/sinvoiceConfig.mixin";
import sinvoiceGoodsMixin from "@/global/mixin/sinvoiceGoods.mixin";
import checkPermission from "@/utils/permission";

export default {
  name: 'InvoiceCreateDialog',
  mixins: [sinvoiceConfigMixin, sinvoiceGoodsMixin],
  props: {
    isOpenInvoiceCreateDialog: { type: Boolean, default: false },
    initialItems: { type: Array, default: () => [] },
    initialDraft: { type: Object, default: () => null },
    editingTransactionUuid: { type: String, default: () => "" },
    kidCode: { type: String, default: () => "" },
    orderKidCode: {
      type: String,
      default: () => ""
    },
    // Bật/tắt việc thêm danh sách hàng hóa mẫu từ store vào bảng items
    useGoodsTemplateFromStore: {
      type: Boolean,
      default: true,
    },
    invoicePurpose: {
      type: String,
      default: () => "ONEKIDS_ORDER"
    },
    isCreateInvoice: {
      type: Boolean,
      default: () => true,
    },
  },
  data() {
    return {
        form: {
        buyerNotGetInvoice: true, // Người mua có lấy hóa đơn không? (boolean)
        paymentStatus: true,
        buyerName: '', //Tên người mua cá nhân
        buyerLegalName: '', // Tên người mua đơn vị tổ chức
        buyerCode: '', // Mã khách hàng
        buyerAddressLine: '',
        buyerTaxCode: '',
        contractNo: '',
        buyerPhoneNumber: '',
        buyerEmail: null,
        buyerIdType: '',
        buyerIdNo: '',
        buyerBankName: '',
        buyerBankAccount: '',
        buyerBudgetCode: '',
        storeCode: '',
        storeName: '',
        paymentMethod: '3',
        paymentMethodName: 'TM/CK',
        currencyCode: 'VND',
        exchangeRate: 1,
        templateCode: '',
        invoiceSeries: '',
        invoiceDate: null,
        // milliseconds timestamp (Long) expected by backend
        invoiceIssuedDate: null,
        // invoiceVatPercent removed: per-request totals are calculated from line taxes
        invoiceNote: "" // Ghi chú cho hóa đơn
      },
      rules: {
        // buyerName + buyerLegalName use conditional validator (at least one field is required)
        buyerName: [],
        buyerLegalName: [],
        buyerTaxCode: [],
        buyerIdNo: [],
        buyerAddressLine: [ { required: true, message: 'Vui lòng nhập địa chỉ người mua', trigger: 'change' } ],
        templateCode: [ { required: true, message: 'Vui lòng chọn mẫu hóa đơn', trigger: 'change' } ],
        invoiceSeries: [ { required: true, message: 'Vui lòng chọn ký hiệu hóa đơn', trigger: 'change' } ],
        invoiceDate: [ { required: true, message: 'Vui lòng chọn ngày lập', trigger: 'change' } ]
        ,paymentMethod: [ { required: true, message: 'Vui lòng chọn hình thức thanh toán', trigger: 'change' } ],
        paymentMethodName: [],
        currencyCode: [ { required: true, message: 'Vui lòng chọn loại tiền', trigger: 'change' } ],
        exchangeRate: [ { required: true, message: 'Vui lòng nhập tỷ giá', trigger: 'blur' } ]
      },

      items: [
        {
          selection: 1,
          // ItemInfoDTO / new fields
          itemName: '',
          unitName: '',
          quantity: 1,
          unitPrice: 0,
          itemTotalAmountWithoutTax: 0,
          taxPercentage: '',
          taxAmount: 0,
          itemNote: ''
        }
      ],
      productOptions:[],
      unitOptions: [
        'Ngày','Tuần','Tháng','Năm','Buổi','Cái','Lần','Gói','Chiếc'
      ],
      productMap: {},
      paymentMethods: [
        { value: "1", label: "TM" },
        { value: "2", label: "CK" },
        { value: "3", label: "TM/CK" },
        { value: "4", label: "DTCN" },
        { value: "5", label: "KHAC" },
        { value: "6", label: "Tiền mặt" },
        { value: "7", label: "Chuyển khoản" },
        { value: "8", label: "Tiền mặt/Chuyển khoản" }
      ],

      paymentMethodMap: {
        "1": "TM",
        "2": "CK",
        "3": "TM/CK",
        "4": "DTCN",
        "5": "KHAC",
        "6": "Tiền mặt",
        "7": "Chuyển khoản",
        "8": "Tiền mặt/Chuyển khoản"
      },
      userInformation: {},
      taxCode: "",
      // top-level lists used by template
      invoiceTemplateOptions: [],
      invoiceSeriesOptions: [],
      actionLoading: {
        preview: false,
        draft: false,
        final: false,
        save: false,
      },
      previewDialogVisible: false,
      previewPayloadText: '',
      previewPdfUrl: null,
      draftSourceRequest: null,
      currencyOptions: [
        "VND","NOK","USD","MYR","KRW","KHR","BRL","CHF","GBP",
        "RUB","SFD","CNY","NZD","HKD","JPY","CAD","THB",
        "EUR","MNK","AUD","LAK","DKK"
      ].sort(),
      confirmIssueDialogVisible: false,
      pendingFinalRequest: null,
      confirmDraftDialogVisible: false,
      // Bật/tắt nguồn hàng mẫu cho selection cột Hàng hóa, dịch vụ
      enableGoodsTemplateSelection: true,
    };
  },
  watch: {
    async isOpenInvoiceCreateDialog(open) {
      if (!open) {
        return;
      }

      // Fetch customer configuration if not already loaded
      if (!this.hasSinvoiceCustomerConfig) {
        try {
          const response = await SinvoiceViettelService.getCustomerInformation();
          if (response.data && response.data.data) {
            let raw = response.data.data;
            if (Array.isArray(raw)) {
              raw = raw.length > 0 ? raw[0] : null;
            }
            if (raw) {
              this.$store.dispatch("sinvoiceCustomerConfigStore/setFromApiData", raw);
            }
          }
        } catch (e) {
          console.warn("Failed to load customer configuration:", e);
        }
      }

      // If form doesn't have templateCode/invoiceSeries set yet, populate them from config
      if (!this.form.templateCode && this.sinvoiceConfig.templateCode) {
        this.form.templateCode = this.sinvoiceConfig.templateCode;
      }
      if (!this.form.invoiceSeries && this.sinvoiceConfig.invoiceSeries) {
        this.form.invoiceSeries = this.sinvoiceConfig.invoiceSeries;
      }

      this.enableGoodsTemplateSelection = !!this.useGoodsTemplateFromStore;

      // sanitize unitOptions: remove empty/blank entries and duplicates
      try {
        const arr = Array.isArray(this.unitOptions) ? this.unitOptions.map(u => String(u || '').trim()).filter(Boolean) : [];
        this.unitOptions = Array.from(new Set(arr));
      } catch (e) {
        // ignore
      }

      const hasInitialDraft = this.hasInitialDraftData();

        if (this.enableGoodsTemplateSelection) {
          try {
            // load full list (no paging) directly
            await this.loadAllSinvoiceGoodsTemplateItems();
          } catch (e) {
            console.warn('loadAllSinvoiceGoodsTemplateItems failed:', e);
          }
        }

      if (hasInitialDraft) {
        this.applyInitialDraftData();
      } else {
        this.draftSourceRequest = null;
        if (Array.isArray(this.initialItems) && this.initialItems.length > 0) {
          this.items = this.mapSourceItemsToDialogItems(this.initialItems);
          this.buildProductOptions();
          this.items.forEach(r => { if (r.itemName) this.onProductChange(r); });
        } else {
          this.items = [this.createEmptyItem()];
          this.buildProductOptions();
        }
      }

      this.recalcAllRows();
      // nếu chưa có ngày lập, khởi tạo bằng thời gian hiện tại
      if (!this.form.invoiceDate) {
        this.form.invoiceDate = new Date();
      }

      // Ensure taxCode and kid info are loaded before requesting templates
      try {
        await this.getTaxCode();
      } catch (e) {
        console.warn('getTaxCode failed:', e);
      }

      if (!hasInitialDraft) {
        try {
          await this.getInformationKids();
        } catch (e) {
          console.warn('getInformationKids failed:', e);
        }
      }

      // load invoice templates into selects (now taxCode is available)
      await this.loadInvoiceTemplateOptions();
      // initialize invoiceIssuedDate from invoiceDate
      if (this.form.invoiceDate) {
        const d = new Date(this.form.invoiceDate);
        if (!Number.isNaN(d.getTime())) this.form.invoiceIssuedDate = d.getTime();
      }
      // Ensure exchangeRate is 1 when currency is VND on dialog open
      if (this.form.currencyCode === 'VND') {
        this.form.exchangeRate = 1;
      }
      this.revalidateBuyerIdentityFields();
    }
    ,
    // Re-validate buyer identity fields when tax code changes
    'form.buyerTaxCode'() {
      this.$nextTick(async () => {
        this.revalidateBuyerIdentityFields();
        // reload invoice templates/series when tax code changes
        try {
          await this.loadInvoiceTemplateOptions();
        } catch (e) {
          // ignore
        }
      });
    }
    ,
    // Re-validate buyerIdNo when type changes
    'form.buyerIdType'() {
      this.$nextTick(() => {
        if (this.$refs.customerForm && this.$refs.customerForm.validateField) {
          this.$refs.customerForm.validateField('buyerIdNo');
        }
      });
    }
    ,
    'form.buyerName'() {
      this.revalidateBuyerIdentityFields();
    }
    ,
    'form.buyerLegalName'() {
      this.revalidateBuyerIdentityFields();
    }
    ,

    // keep invoiceIssuedDate in sync (backend expects Long milliseconds)
    'form.invoiceDate'(newVal) {
      // if newVal is null/empty, clear invoiceIssuedDate
      if (!newVal) {
        this.form.invoiceIssuedDate = null;
        return;
      }
      const d = new Date(newVal);
      if (Number.isNaN(d.getTime())) {
        this.form.invoiceIssuedDate = null;
      } else {
        this.form.invoiceIssuedDate = d.getTime();
      }
    }
    ,
    // Ensure exchange rate is 1 when user selects VND
    'form.currencyCode'(newVal) {
      try {
        if (String(newVal) === 'VND') {
          // set to 1 (use $nextTick to avoid interfering with v-model events)
          this.$nextTick(() => { this.form.exchangeRate = 1; });
        }
      } catch (e) {
        // ignore
      }
    }
  },

  created() {
    // register conditional validator: require at least one of buyerName/buyerLegalName
    this.rules.buyerName = [
      { validator: this.buyerNameOrLegalNameValidator, trigger: 'blur' },
      { validator: this.buyerNameOrLegalNameValidator, trigger: 'change' }
    ];
    this.rules.buyerLegalName = [
      { validator: this.buyerNameOrLegalNameValidator, trigger: 'blur' },
      { validator: this.buyerNameOrLegalNameValidator, trigger: 'change' }
    ];
    this.rules.buyerTaxCode = [
      { validator: this.buyerTaxCodeByLegalNameValidator, trigger: 'blur' },
      { validator: this.buyerTaxCodeByLegalNameValidator, trigger: 'change' }
    ];
    // register conditional validator for paymentMethodName (required only when paymentMethod === '5')
    this.rules.paymentMethodName = [ { validator: this.paymentMethodNameValidator, trigger: 'blur' } ];
    // register conditional validator for buyerIdNo when buyerIdType is present
    this.rules.buyerIdNo = [ { validator: this.buyerIdNoValidator, trigger: 'blur' } ];
    // register conditional validator for buyerAddressLine when buyerNotGetInvoice is false
    this.rules.buyerAddressLine = [ { validator: this.buyerAddressValidator, trigger: 'blur' } ];
    // sanitize unitOptions on component creation: remove empty entries and duplicates
    try {
      if (Array.isArray(this.unitOptions)) {
        const arr = this.unitOptions.map(u => String(u || '').trim()).filter(Boolean);
        this.unitOptions = Array.from(new Set(arr));
      }
    } catch (e) {
      // ignore
    }
  },

   computed: {
     dialogTitle() {
       const hasEditingDraft = this.draftSourceRequest && Object.keys(this.draftSourceRequest).length > 0;
       return hasEditingDraft ? 'Chỉnh sửa hóa đơn' : 'Tạo hóa đơn';
     },
     // Tổng tiền hàng (không tính dòng Chiết khấu)
    subtotal(){
      return this.items.reduce((s, i) => {
        if (Number(i.selection) === 3) return s;
        return s + (Number(i.itemTotalAmountWithoutTax) || 0);
      }, 0);
    },

    // Tổng tiền thuế (tổng tiền thuế của từng dòng)
    lineTaxTotal(){
      return this.items.reduce((s, i) => {
        return s + (Number(i.taxAmount) || 0);
      }, 0);
    },

    // Tổng tiền chiết khấu thực tế: chiết khấu theo dòng + dòng chiết khấu riêng (selection=3)
    totalInvoiceDiscountAmount() {
      return (Number(this.totalDiscountAmount) || 0) + (Number(this.totalSelectionDiscountAmount) || 0);
    },

    // Tổng tiền trước thuế = tổng tiền hàng - toàn bộ chiết khấu
    totalBeforeTax() {
      return (Number(this.subtotal) || 0) - (Number(this.totalInvoiceDiscountAmount) || 0);
    },

    // Tổng chiết khấu từ dòng selection=3 (luôn dương để trừ vào tổng)
    totalSelectionDiscountAmount() {
      return this.items.reduce((s, i) => {
        if (Number(i.selection) !== 3) return s;
        return s + Math.abs(Number(i.itemTotalAmountWithoutTax) || 0);
      }, 0);
    },

    // Tổng tiền chiết khấu toàn hóa đơn
    totalDiscountAmount() {
      return this.items.reduce((s, i) => {
        return s + (Number(i.itemDiscount) || 0);
      }, 0);
    },

    // Tổng tiền sau thuế = tổng trước thuế + tổng thuế
    totalAfterTax() {
      return this.totalBeforeTax + this.lineTaxTotal;
    },

    // Tổng thanh toán hiển thị cho người dùng (bằng tổng sau thuế)
    grandTotal(){
      return this.totalAfterTax;
    },

    totalInWords() {
      try {
        const money = Math.round(Number(this.grandTotal) || 0);
        return this.normalizeMoneyText(ConvertMoneyToString(money), money);
      } catch (e) {
        const money = Math.round(Number(this.grandTotal) || 0);
        return `${new Intl.NumberFormat('vi-VN').format(money)} đồng`;
      }
    },

    // words for the selected currency: if VND use ConvertMoneyToString, otherwise show formatted number + currency code
    totalInWordsCurrency() {
      const code = this.form.currencyCode || 'VND';
      const amount = Math.round(Number(this.grandTotal) || 0);
      if (code === 'VND') {
        try {
          return this.normalizeMoneyText(ConvertMoneyToString(amount), amount);
        } catch (e) {
          return `${new Intl.NumberFormat('vi-VN').format(amount)} đồng`;
        }
      }
      // For non-VND currencies, fallback to localized format + currency code
      return `${new Intl.NumberFormat(undefined, { maximumFractionDigits: 2 }).format(amount)} ${code}`;
    },


    // Mapping theo SummarizeInfoDTO
    summarizeInfo() {
      const totalAmountWithoutTax = Number(this.subtotal) || 0;
      const totalTaxAmount = Number(this.lineTaxTotal) || 0;
      const totalAmountWithTax = totalAmountWithoutTax + totalTaxAmount;
      const discountAmount = Number(this.totalInvoiceDiscountAmount) || 0;
      const totalAmountAfterDiscount = totalAmountWithTax - discountAmount;
      const invoiceNote = this.form && this.form.invoiceNote ? String(this.form.invoiceNote).trim() : '';

      return {
        totalAmountWithoutTax,
        totalTaxAmount,
        totalAmountWithTax,
        totalAmountWithTaxFrn: this.form.currencyCode && this.form.currencyCode !== 'VND' ? totalAmountAfterDiscount : null,
        // Giữ theo tổng thanh toán cuối cùng đang hiển thị trên UI
        totalAmountWithTaxInWords: this.totalInWords,
        isTotalAmountPos: totalAmountWithTax >= 0,
        isTotalTaxAmountPos: totalTaxAmount >= 0,
        isTotalAmtWithoutTaxPos: totalAmountWithoutTax >= 0,
        discountAmount,
        settlementDiscountAmount: 0,
        isDiscountAmtPos: discountAmount >= 0,
        extraName: invoiceNote ? 'Ghi chú' : null,
        extraValue: invoiceNote || null,
        totalAmountAfterDiscount
      };
    }
  },
  methods: {
    checkPermission,
    cloneData(value) {
      if (value === null || value === undefined) return value;
      try {
        return JSON.parse(JSON.stringify(value));
      } catch (e) {
        return value;
      }
    },
    hasInitialDraftData() {
      return !!(this.initialDraft && typeof this.initialDraft === 'object' && Object.keys(this.initialDraft).length > 0);
    },
    async handleGoodsTemplateToggle(value) {
      this.enableGoodsTemplateSelection = !!value;
        if (this.enableGoodsTemplateSelection) {
          try {
            await this.loadAllSinvoiceGoodsTemplateItems();
          } catch (e) {
            console.warn('loadAllSinvoiceGoodsTemplateItems failed:', e);
          }
        }
      this.buildProductOptions();
    },
    createDefaultFormState() {
      const now = new Date();
      return {
        buyerNotGetInvoice: false,
        paymentStatus: true,
        buyerName: '',
        buyerLegalName: '',
        buyerCode: '',
        buyerAddressLine: '',
        buyerTaxCode: '',
        contractNo: '',
        buyerPhoneNumber: '',
        buyerEmail: null,
        buyerIdType: '',
        buyerIdNo: '',
        buyerBankName: '',
        buyerBankAccount: '',
        buyerBudgetCode: '',
        storeCode: '',
        storeName: '',
        paymentMethod: '3',
        paymentMethodName: 'TM/CK',
        currencyCode: 'VND',
        exchangeRate: 1,
        templateCode: this.sinvoiceConfig.templateCode || '',
        invoiceSeries: this.sinvoiceConfig.invoiceSeries || '',
        invoiceDate: now,
        invoiceIssuedDate: now.getTime(),
        invoiceNote: ''
      };
    },
    mapSourceItemsToDialogItems(sourceItems = []) {
      if (!Array.isArray(sourceItems) || sourceItems.length === 0) {
        return [this.createEmptyItem()];
      }

      return sourceItems.map(i => {
        const productName = i.itemName || i.product || i.nameKt || i.name || i.productName || '';
        const unitName = i.unitName || i.unit || '';
        const unitCode = i.unitCode || '';
        const qty = i.quantity !== undefined && i.quantity !== null ? i.quantity : (i.quantityKt !== undefined && i.quantityKt !== null ? i.quantityKt : 1);
        const unitPrice = i.unitPrice !== undefined && i.unitPrice !== null ? i.unitPrice : (i.price !== undefined && i.price !== null ? i.price : (i.priceKt !== undefined && i.priceKt !== null ? i.priceKt : 0));
        // Determine tax percentage from various possible source fields.
        // If none provided, keep as empty string so the UI shows the placeholder (no selection)
        let taxPerc = (i.taxPercentage !== undefined && i.taxPercentage !== null && i.taxPercentage !== '')
          ? i.taxPercentage
          : (i.taxPercent !== undefined && i.taxPercent !== null && i.taxPercent !== '')
            ? i.taxPercent
            : (i.vatPercent !== undefined && i.vatPercent !== null && i.vatPercent !== '')
              ? i.vatPercent
              : '';
        // Normalize explicit zero (0 or '0') to empty so initial dialog shows no selection
        if (taxPerc !== '' && Number(taxPerc) === 0) {
          taxPerc = '';
        }
        const isSpecialNoTaxCode = String(taxPerc).trim() === '-1' || String(taxPerc).trim() === '-2';
        const itemTotalWithoutTax = i.itemTotalAmountWithoutTax !== undefined && i.itemTotalAmountWithoutTax !== null
          ? Number(i.itemTotalAmountWithoutTax)
          : Number(qty || 0) * Number(unitPrice || 0);

        const obj = {
          selection: i.selection !== undefined && i.selection !== null ? i.selection : 1,
          lineNumber: i.lineNumber || null,
          itemType: i.itemType || null,
          itemCode: i.itemCode || i.code || null,
          itemName: i.itemName || productName || '',
          unitCode: unitCode || null,
          unitName: unitName || '',
          unitPrice: unitPrice !== undefined && unitPrice !== null ? Number(unitPrice) : 0,
          quantity: qty !== undefined && qty !== null ? Number(qty) : 1,
          itemTotalAmountWithoutTax: Number(itemTotalWithoutTax),
          taxPercentage: (taxPerc !== undefined && taxPerc !== null && taxPerc !== '') ? (String(taxPerc) === 'cttc' || String(taxPerc) === 'other' ? taxPerc : Number(taxPerc)) : '',
          // Only initialize taxPercentageInput when source provides a meaningful non-zero numeric value
          taxPercentageInput: (String(taxPerc) === 'cttc' || String(taxPerc) === 'other') && (i.taxPercentageNumeric !== undefined && i.taxPercentageNumeric !== null && String(i.taxPercentageNumeric).trim() !== '') && Number(i.taxPercentageNumeric) !== 0 ? Number(i.taxPercentageNumeric) : null,
          taxAmount: isSpecialNoTaxCode ? 0 : (i.taxAmount !== undefined && i.taxAmount !== null ? Number(i.taxAmount) : 0),
          taxAmountFromBackend: !isSpecialNoTaxCode && i.taxAmount !== undefined && i.taxAmount !== null,
          quantityDisplay: this.formatQuantityDisplay(qty !== undefined && qty !== null ? Number(qty) : 1),
          unitPriceDisplay: this.formatNumberDisplay(unitPrice !== undefined && unitPrice !== null ? Number(unitPrice) : 0),
          itemTotalAmountWithoutTaxDisplay: this.formatNumberDisplay(Number(itemTotalWithoutTax) || 0),
          isIncreaseItem: i.isIncreaseItem !== undefined ? i.isIncreaseItem : true,
          itemNote: i.itemNote || i.note || '',
          batchNo: i.batchNo || null,
          expDate: i.expDate || null,
          discount: i.discount !== undefined && i.discount !== null ? i.discount : 0,
          discount2: i.discount2 !== undefined && i.discount2 !== null ? i.discount2 : 0,
          itemDiscount: i.itemDiscount !== undefined && i.itemDiscount !== null ? Number(i.itemDiscount) : 0,
          itemTotalAmountAfterDiscount: i.itemTotalAmountAfterDiscount !== undefined && i.itemTotalAmountAfterDiscount !== null ? Number(i.itemTotalAmountAfterDiscount) : null,
          itemTotalAmountWithTax: i.itemTotalAmountWithTax !== undefined && i.itemTotalAmountWithTax !== null ? Number(i.itemTotalAmountWithTax) : null,
          adjustRatio: i.adjustRatio || null,
          unitPriceWithTax: i.unitPriceWithTax || null,
          specialInfo: i.specialInfo || null,
          regulation: i.regulation || null,
          itemNameDisplay: i.itemName || productName || '',
          total: itemTotalWithoutTax,
          // control flags; will be normalized by ensureRowState
          allowQuantity: true,
          allowUnitPrice: true,
          allowTotalAmount: true,
          allowProduct: true,
          allowUnitName: true,
          allowTax: true,
          excludeFromTotals: false
        };
        // normalize flags according to selection type
        try {
          if (this && typeof this.ensureRowState === 'function') this.ensureRowState(obj);
        } catch (e) {
          // ignore
        }
        // ensure unit is present in unitOptions (only when unitName provided)
        try { if (obj.unitName) this.addUnitIfMissing(obj.unitName); } catch (e) {console.log(e)}
        return obj;
      });
    },
    applyInitialDraftData() {
      const draft = this.cloneData(this.initialDraft) || {};
      const generalInvoiceInfo = draft.generalInvoiceInfo || {};
      const buyerInfo = draft.buyerInfo || {};
      const sellerInfo = draft.sellerInfo || {};
      const payment = Array.isArray(draft.payments) && draft.payments.length > 0 ? draft.payments[0] : {};
      const invoiceIssuedDate = Number(generalInvoiceInfo.invoiceIssuedDate) || null;
      const invoiceDate = invoiceIssuedDate ? new Date(invoiceIssuedDate) : new Date();
      const buyerNotGetInvoice = Number(buyerInfo.buyerNotGetInvoice) === 1 || generalInvoiceInfo.cusGetInvoiceRight === false;

      this.draftSourceRequest = draft;
      this.form = {
        ...this.createDefaultFormState(),
        buyerNotGetInvoice,
        paymentStatus: generalInvoiceInfo.paymentStatus !== undefined ? !!generalInvoiceInfo.paymentStatus : true,
        buyerName: buyerInfo.buyerName || '',
        buyerLegalName: buyerInfo.buyerLegalName || '',
        buyerCode: buyerInfo.buyerCode || '',
        buyerAddressLine: buyerInfo.buyerAddressLine || '',
        buyerTaxCode: buyerInfo.buyerTaxCode || '',
        contractNo: buyerInfo.contractNo || '',
        buyerPhoneNumber: buyerInfo.buyerPhoneNumber || '',
        buyerEmail: buyerInfo.buyerEmail || null,
        buyerIdType: buyerInfo.buyerIdType || '',
        buyerIdNo: buyerInfo.buyerIdNo || '',
        buyerBankName: buyerInfo.buyerBankName || '',
        buyerBankAccount: buyerInfo.buyerBankAccount || '',
        buyerBudgetCode: buyerInfo.buyerBudgetCode || '',
        storeCode: sellerInfo.storeCode || '',
        storeName: sellerInfo.storeName || '',
        paymentMethod: payment.paymentMethod || '3',
        paymentMethodName: payment.paymentMethodName || 'TM/CK',
        currencyCode: generalInvoiceInfo.currencyCode || 'VND',
        exchangeRate: String(generalInvoiceInfo.currencyCode || 'VND') === 'VND' ? 1 : (generalInvoiceInfo.exchangeRate !== undefined && generalInvoiceInfo.exchangeRate !== null ? generalInvoiceInfo.exchangeRate : 1),
        templateCode: generalInvoiceInfo.templateCode || this.sinvoiceConfig.templateCode || '',
        invoiceSeries: generalInvoiceInfo.invoiceSeries || this.sinvoiceConfig.invoiceSeries || '',
        invoiceDate,
        invoiceIssuedDate: invoiceIssuedDate || invoiceDate.getTime(),
        invoiceNote: generalInvoiceInfo.invoiceNote || ''
      };
      this.items = this.mapSourceItemsToDialogItems(draft.itemInfo || []);
      this.buildProductOptions();
      this.items.forEach(r => { if (r.itemName) this.onProductChange(r); });
      this.$nextTick(() => {
        if (this.$refs.customerForm && this.$refs.customerForm.clearValidate) this.$refs.customerForm.clearValidate();
        if (this.$refs.invoiceForm && this.$refs.invoiceForm.clearValidate) this.$refs.invoiceForm.clearValidate();
      });
    },
    resolveEditingTransactionUuid() {
      const propTransactionUuid = this.editingTransactionUuid ? String(this.editingTransactionUuid).trim() : '';
      if (propTransactionUuid) return propTransactionUuid;
      const draftTransactionUuid = this.draftSourceRequest && this.draftSourceRequest.generalInvoiceInfo && this.draftSourceRequest.generalInvoiceInfo.transactionUuid
        ? String(this.draftSourceRequest.generalInvoiceInfo.transactionUuid).trim()
        : '';
      return draftTransactionUuid;
    },
    // Build productOptions list from initialItems (deduplicated)
    buildProductOptions() {
      try {
        const src = Array.isArray(this.initialItems) && this.initialItems.length > 0 ? this.initialItems : this.items || [];
        const sourceList = Array.isArray(src) ? [...src] : [];
        if (this.enableGoodsTemplateSelection) {
          const templateItems = this.getSinvoiceGoodsTemplateItems();
          if (Array.isArray(templateItems) && templateItems.length > 0) {
            sourceList.push(...templateItems);
          }
        }
        const map = new Map();
        const productMapObj = {};
        sourceList.forEach(i => {
          const name = i.itemName || i.product || i.nameKt || i.name || i.productName || '';
          if (!name) return;
          const code = i.code || i.productCode || i.itemCode || '';
          const optionUnit = i.unitName || i.unit || '';
          const optionPrice = i.unitPrice !== undefined && i.unitPrice !== null
            ? i.unitPrice
            : (i.price !== undefined && i.price !== null ? i.price : (i.priceKt !== undefined && i.priceKt !== null ? i.priceKt : null));
          if (!map.has(name)) map.set(name, { code, name, unit: optionUnit, price: optionPrice });
          // store detailed info for quick lookup when product selected
          if (!productMapObj[name]) {
            let mappedTaxPercent = i.taxPercentage !== undefined && i.taxPercentage !== null && i.taxPercentage !== ''
              ? i.taxPercentage
              : (i.taxPercent !== undefined && i.taxPercent !== null && i.taxPercent !== ''
                ? i.taxPercent
                : (i.vatPercent !== undefined && i.vatPercent !== null && i.vatPercent !== '' ? i.vatPercent : ''));
            // Keep initial state as "no selection" instead of forcing 0%
            if (mappedTaxPercent !== '' && Number(mappedTaxPercent) === 0) mappedTaxPercent = '';
            productMapObj[name] = {
              code: code || null,
              name,
              isCustom: false,
              unit: i.unitName || i.unit || '',
              price: i.unitPrice !== undefined && i.unitPrice !== null ? i.unitPrice : (i.price !== undefined && i.price !== null ? i.price : (i.priceKt !== undefined && i.priceKt !== null ? i.priceKt : 0)),
              quantity: i.quantity !== undefined && i.quantity !== null ? i.quantity : (i.quantityKt !== undefined && i.quantityKt !== null ? i.quantityKt : 1),
              taxPercent: mappedTaxPercent
            };
          }
        });
        this.productOptions = Array.from(map.values());
        this.productMap = productMapObj;
      } catch (e) {
        console.warn('buildProductOptions failed', e);
        this.productOptions = [];
        this.productMap = {};
      }
    },
    formatProductOptionMeta(option = {}) {
      const optionName = option && option.name ? option.name : '';
      const info = optionName && this.productMap ? this.productMap[optionName] : null;
      const rawPrice = info && info.price !== undefined && info.price !== null ? info.price : option.price;
      const unitName = (info && info.unit) || option.unit || '';

      const hasPrice = rawPrice !== undefined && rawPrice !== null && String(rawPrice).trim() !== '';
      const priceText = hasPrice
        ? `${new Intl.NumberFormat('vi-VN').format(Number(rawPrice) || 0)}đ`
        : '--';
      const unitText = unitName ? String(unitName).trim() : '--';

      return `${priceText}/${unitText}`;
    },
    getProductOptionCode(option = {}) {
      const optionName = option && option.name ? option.name : '';
      const info = optionName && this.productMap ? this.productMap[optionName] : null;
      const code = (info && info.code) || option.code || '';
      const normalized = String(code || '').trim();
      return normalized || '';
    },

    async getInformationKids(){
      try {
        const res = await SinvoiceViettelService.getInformationKids(this.$props.kidCode);
        if (res && res.data && res.data.data) {
          this.userInformation = res.data.data;
          this.form.buyerName = res.data.data.name;
          this.form.buyerCode = res.data.data.kidCode;
          this.form.buyerAddressLine = res.data.data.address;
          this.form.buyerPhoneNumber = res.data.data.phone;
          this.form.buyerEmail = res.data.data.email;
          if (this.form.buyerEmail === "") {
            this.form.buyerEmail = null;
          }
          this.form.buyerTaxCode = res.data.data.taxIdentificationNumber;
          this.form.buyerBankAccount = res.data.data.accountNumberStudent;
          this.form.buyerBankName = res.data.data.bankNameStudent;
        }
      } catch (err) {
        console.error('Failed to get user information:', err);
      }
    },
    async getTaxCode(){
      try {
        const res = await SinvoiceViettelService.getTaxCode();
        if (res && res.data && res.data.data) {
          this.taxCode = res.data.data;
        }
      } catch (err) {
        console.error('Failed to get taxCode information:', err);
      }
    },


    onPaymentMethodChange(value) {

      // nếu không phải KHAC thì tự fill
      if (value !== "5") {
        this.form.paymentMethodName = this.paymentMethodMap[value]
      } else {
        this.form.paymentMethodName = ""
      }

    },
    async loadInvoiceTemplateOptions() {
      try {
        const taxParam = this.taxCode || this.form.buyerTaxCode || (this.userInformation && this.userInformation.taxIdentificationNumber) || '';
        const data = { taxCode: taxParam, invoiceType: 'all' };
        const response = await ElectronicInvoicesService.syncInvoiceTemplateList(data);
        const list = Array.isArray(response.data && response.data.data) ? response.data.data : [];

        const mapped = list
            .map(item => {
              const template = item.templateCode || item.template || item.template_code || '';
              const serial = item.invoiceSeri || item.invoiceSerial || item.serial || item.invoice_seri || item.invoice_serial || '';
              return (template || serial) ? { template: template || '', serial: serial || '' , raw: item } : null;
            })
            .filter(Boolean);

        const pairs = mapped.map(m => ({ template: m.template || '', serial: m.serial || '' }));

        const templates = Array.from(new Set(pairs.map(i => i.template))).map(t => ({ value: t, label: t || '(Mẫu mặc định)' }));
        this.invoiceTemplateOptions = templates;

        // Only populate invoiceSeriesOptions when a template has already been selected
        const currentTemplate = this.form.templateCode || '';
        if (currentTemplate) {
          this.invoiceSeriesOptions = pairs.filter(i => i.template === currentTemplate).map(i => ({ value: i.serial, label: i.serial }));
        } else {
          this.invoiceSeriesOptions = [];
        }

        // If there are no templates (templates list empty) but the raw list has series, use them as fallback
        if (templates.length === 0 && list.length > 0) {
          const fallbackSeries = Array.from(new Set(list.map(item => item.invoiceSeri || item.invoiceSerial || item.serial || '').filter(Boolean))).map(s => ({ value: s, label: s }));
          this.invoiceSeriesOptions = fallbackSeries;
        }

        // Do NOT auto-select a templateCode on dialog open. Preserve existing value (may be empty)
        // Only auto-select invoiceSeries when a templateCode is present (e.g., editing a draft)
        if (this.form.templateCode && !this.form.invoiceSeries && this.invoiceSeriesOptions.length > 0) {
          this.form.invoiceSeries = this.invoiceSeriesOptions[0].value;
        }

        if (templates.length === 0 && list.length > 0) {
          console.debug('loadInvoiceTemplateOptions: mapped templates empty but raw list has entries', { list });
        }
      } catch (err) {
        console.error('Failed to load invoice templates:', err);
      }
    },

    async onInvoiceTemplateChange(value) {
      if (!value) {
        this.invoiceSeriesOptions = [];
        this.form.invoiceSeries = '';
        return;
      }
      try {
        // use this.taxCode (loaded earlier) as Sinvoice API expects
        const data = { taxCode: this.taxCode || '', invoiceType: 'all' };
        const response = await ElectronicInvoicesService.syncInvoiceTemplateList(data);
        const list = Array.isArray(response.data && response.data.data) ? response.data.data : [];
        const mapped = list
            .map(item => ({ template: item.templateCode || item.template || '', serial: item.invoiceSeri || item.invoiceSerial || item.serial || '' }))
            .filter(i => i.template && i.serial && i.template === value);
        this.invoiceSeriesOptions = mapped.map(i => ({ value: i.serial, label: i.serial }));
          // auto-select the first series when template changes (triggered by user selection)
            if (this.invoiceSeriesOptions.length > 0) {
              this.form.invoiceSeries = this.invoiceSeriesOptions[0].value;
            } else {
              this.form.invoiceSeries = '';
            }
      } catch (err) {
        console.error('Failed to refresh invoice series:', err);
      }
    },

    // when user selects a product in a row, auto-fill unit, quantity, price, taxPercent and DTO fields
    onProductChange(row) {
      if (!row) return;
      // the select is bound to row.itemName; use that as primary key, fallback to legacy row.product
      const key = row.itemName || row.product || '';
      if (!key) return;
      let info = this.productMap && this.productMap[key];

      // allow-create: if product does not exist yet, add it to the list like unitOptions
      if (!info) {
        row.itemName = this.addProductIfMissing(key, row);
        row.itemCode = null;
        row.unitCode = null;
        this.calculateRow(row);
        return;
      }

      // UI legacy compatibility (if any present)
      if (info.unit !== undefined) {
        row.unitName = info.unit;
        // ensure unit is available in unitOptions
        this.addUnitIfMissing(info.unit);
      }
      if (info.quantity !== undefined) row.quantity = info.quantity;
      if (info.price !== undefined) row.unitPrice = info.price;
      if (info.taxPercent !== undefined) {
        const _t = info.taxPercent;
        if (_t === null || String(_t).trim() === '') {
          row.taxPercentage = '';
        } else if (!isNaN(Number(_t))) {
          row.taxPercentage = Number(_t);
        } else {
          row.taxPercentage = String(_t);
        }
      }

      // DTO / canonical fields
      row.itemName = info.name || row.itemName || null;
      row.itemCode = info.code || row.itemCode || null;
      row.unitName = info.unit || row.unitName || "";
      row.unitCode = info.unitCode || row.unitCode || null;
      row.unitPrice = info.price !== undefined ? Number(info.price) : row.unitPrice;
      row.quantity = info.quantity !== undefined ? Number(info.quantity) : row.quantity;
      if (info.taxPercent !== undefined) {
        const _t2 = info.taxPercent;
        if (_t2 === null || String(_t2).trim() === '') {
          row.taxPercentage = '';
        } else if (!isNaN(Number(_t2))) {
          row.taxPercentage = Number(_t2);
        } else {
          row.taxPercentage = String(_t2);
        }
      }

      // Initialize display fields with formatted values
      row.quantityDisplay = this.formatQuantityDisplay(row.quantity);
      row.unitPriceDisplay = this.formatNumberDisplay(row.unitPrice);

      this.calculateRow(row);
    },

    addUnitIfMissing(unit) {
      try {
        const u = String(unit || '').trim();
        if (!u) return;
        const exists = (this.unitOptions || []).some(x => String(x || '').trim().toLowerCase() === u.toLowerCase());
        if (!exists) this.unitOptions.push(u);
      } catch (e) {
        // ignore
      }
    },
    syncCustomProductDefaults(row) {
      try {
        if (!row) return;
        const productName = String(row.itemName || '').trim();
        if (!productName || !this.productMap || !this.productMap[productName] || !this.productMap[productName].isCustom) return;

        this.productMap[productName] = {
          ...this.productMap[productName],
          unit: row.unitName ? String(row.unitName).trim() : '',
          price: row.unitPrice !== undefined && row.unitPrice !== null ? Number(row.unitPrice) || 0 : 0,
          taxPercent: row.taxPercentage !== undefined && row.taxPercentage !== null ? row.taxPercentage : ''
        };
      } catch (e) {
        // ignore
      }
    },
    onUnitNameChange(row) {
      this.addUnitIfMissing(row && row.unitName);
      this.syncCustomProductDefaults(row);
    },
    addProductIfMissing(name, row = null) {
      try {
        const productName = String(name || '').trim();
        if (!productName) return '';

        const existing = (this.productOptions || []).find(
          x => String((x && x.name) || '').trim().toLowerCase() === productName.toLowerCase()
        );

        const finalName = existing ? existing.name : productName;

        if (!existing) {
          const option = { code: null, name: finalName };
          this.productOptions.push(option);
        }

        if (!this.productMap) this.productMap = {};
        if (!this.productMap[finalName]) {
          this.productMap[finalName] = {
            code: null,
            name: finalName,
            isCustom: true,
            unit: row && row.unitName ? row.unitName : '',
            price: row && row.unitPrice !== undefined && row.unitPrice !== null ? row.unitPrice : 0,
            quantity: row && row.quantity !== undefined && row.quantity !== null ? row.quantity : 1,
            taxPercent: row && row.taxPercentage !== undefined && row.taxPercentage !== null ? row.taxPercentage : ''
          };
        }

        return finalName;
      } catch (e) {
        return String(name || '').trim();
      }
    },

    createEmptyItem() {
      const base = {
        selection: 1,
        // DTO fields
        itemName: '',
        itemCode: null,
        unitName: '',
        unitCode: null,
        quantity: 1,
        quantityDisplay: '1',
        unitPrice: 0,
        unitPriceDisplay: '0',
        itemTotalAmountWithoutTax: 0,
        itemTotalAmountWithoutTaxDisplay: '0',
        taxPercentage: '',
        taxPercentageInput: null,
        taxAmount: 0,
        taxAmountFromBackend: false,
        itemNote: '',
        // control flags for item types
        allowQuantity: true,
        allowUnitPrice: true,
        allowTotalAmount: true,
        allowProduct: true,
        allowUnitName: true,
        allowTax: true,
        isIncreaseItem: true,
        excludeFromTotals: false
      };
      // ensure proper flags per selection
      this.ensureRowState(base);
      // ensure default unit exists in unitOptions (only non-empty)
      try { if (base.unitName) this.addUnitIfMissing(base.unitName); } catch (e) {console.log(e);}
      return base;
    },
    recalcAllRows() {
      if (!Array.isArray(this.items)) return;
      this.items.forEach(r => this.calculateRow(r));
    },
    // Compute visible index (STT) counting only item types that should show an index
    computeVisibleIndex(row) {
      if (!Array.isArray(this.items)) return '';
      // types that should have STT: 1 (Hàng hóa) and 5 (Khuyến mại)
      const typesToCount = [1,5];
      let idx = 0;
      for (const r of this.items) {
        if (typesToCount.includes(Number(r.selection))) {
          idx++;
        }
        if (r === row) {
          return typesToCount.includes(Number(r.selection)) ? idx : '';
        }
      }
      return '';
    },

    onSelectionChange(row) {
      // update row flags and default values based on selection
      this.ensureRowState(row);
      // ensure DOM/reactive updates applied (fix controls remaining disabled)
      this.$nextTick(() => {
        // re-apply to be safe and then recalc amounts
        this.ensureRowState(row);
        this.calculateRow(row);
      });
    },
    getProductPlaceholder(row) {
      const sel = Number(row && row.selection);
      if (sel === 2) return 'Nhập nội dung diễn giải';
      if (sel === 3) return 'Nhập nội dung chiết khấu';
      return '--Lựa chọn--';
    },

    ensureRowState(row) {
      const sel = Number(row.selection) || 1;
      // helper to set reactive props
      const set = (key, val) => { try { if (this && this.$set) this.$set(row, key, val); else row[key] = val; } catch (e) { row[key] = val; } };

      // Defaults (reactive)
      set('allowQuantity', true);
      set('allowUnitPrice', true);
      set('allowTotalAmount', true);
      set('allowProduct', true);
      set('allowUnitName', true);
      set('allowTax', true);
      set('isIncreaseItem', true);
      set('excludeFromTotals', false);

      switch (sel) {
        case 1: // Hàng hóa
          set('allowQuantity', true);
          set('allowUnitPrice', true);
          set('isIncreaseItem', true);
          set('excludeFromTotals', false);
          set('allowUnitName', true);
          set('allowTax', true);
          set('allowProduct', true);
          break;
        case 2: // Ghi chú
          set('allowQuantity', false);
          set('allowUnitPrice', false);
          set('allowTotalAmount', false);
          set('isIncreaseItem', true);
          set('excludeFromTotals', true); // does not affect totals
          // Reset all non-itemName fields to null to avoid sending unintended values
          set('itemCode', null);
          set('unitCode', null);
          set('unitName', null);
          set('quantity', null);
          set('quantityDisplay', '');
          set('unitPrice', null);
          set('unitPriceDisplay', '');
          set('itemTotalAmountWithoutTax', null);
          set('itemTotalAmountWithoutTaxDisplay', '');
          set('itemTotalAmountAfterDiscount', null);
          set('itemTotalAmountWithTax', null);
          set('discount', null);
          set('discount2', null);
          set('itemDiscount', null);
          // keep allowProduct = true so product select is always enabled
          set('allowUnitName', false);
          set('allowTax', false);
          set('taxPercentage', null);
          set('taxAmount', null);
          set('taxPercentageInput', null);
          break;
        case 3: // Chiết khấu
          set('allowQuantity', false);
          set('allowUnitPrice', false);
          set('allowTotalAmount', true);
          set('isIncreaseItem', false); // indicates reduction
          set('excludeFromTotals', false);
          // Discount line uses manual total; quantity/unitPrice must stay null
          set('quantity', null);
          set('quantityDisplay', '');
          set('unitPrice', null);
          set('unitPriceDisplay', '');
          set('itemTotalAmountAfterDiscount', null);
          set('itemTotalAmountWithTax', null);
          set('itemDiscount', null);
          // keep allowProduct = true so product select remains enabled
          set('allowUnitName', false);
          set('allowTax', false);
           set('taxPercentage', '');
           set('taxAmount', null);
           set('taxPercentageInput', null);
          break;
        case 4: // Phí khác
          set('allowQuantity', false);
          set('allowUnitPrice', false);
          set('allowTotalAmount', true);
          set('isIncreaseItem', true);
          set('excludeFromTotals', false);
          set('quantity', 1);
          set('quantityDisplay', '1');
          // keep allowProduct = true so product select remains enabled
          set('allowUnitName', false);
          set('allowTax', false);
           set('taxPercentage', '');
           set('taxAmount', 0);
           set('taxPercentageInput', null);
          break;
        case 5: // Khuyến mại
          set('allowQuantity', true);
          set('allowUnitPrice', true);
          set('isIncreaseItem', true);
          set('excludeFromTotals', false);
          set('allowProduct', true);
          set('allowUnitName', true);
          set('allowTax', true);
          break;
        default:
          break;
      }
    },
    getPercentNumber(value) {
      if (value === undefined || value === null || value === '') {
        return 0;
      }

      if (typeof value === 'number') {
        return Number.isFinite(value) ? value : 0;
      }

      const normalizedValue = String(value).trim().replace('%', '');
      const parsedValue = Number(normalizedValue);
      return Number.isFinite(parsedValue) ? parsedValue : 0;
    },
    normalizeMoneyText(value, money) {
      if (typeof value !== 'string' || !value.trim()) {
        return money === 0 ? 'Không đồng.' : `${new Intl.NumberFormat('vi-VN').format(money)} đồng`;
      }

      return value
          .replace(/\s+/g, ' ')
          .replace(/\s([,.!])/g, '$1')
          .replace(/!$/, '.')
          .trim();
    },
    calculateRow(row){
      // Manual total mode (e.g., Chiết khấu/Phí khác): do not derive from quantity * unitPrice
      if (row && row.allowTotalAmount && !row.allowUnitPrice && !row.excludeFromTotals) {
        const hasDisplay = row.itemTotalAmountWithoutTaxDisplay !== undefined && row.itemTotalAmountWithoutTaxDisplay !== null && String(row.itemTotalAmountWithoutTaxDisplay).trim() !== '';
        const manualValue = hasDisplay
          ? this.parseNumberInput(row.itemTotalAmountWithoutTaxDisplay)
          : (row.itemTotalAmountWithoutTax !== undefined && row.itemTotalAmountWithoutTax !== null ? Number(row.itemTotalAmountWithoutTax) : null);

        if (manualValue === null || Number.isNaN(Number(manualValue))) {
          row.itemTotalAmountWithoutTax = null;
          row.itemTotalAmountWithoutTaxDisplay = '';
          row.taxAmount = null;
          return;
        }

        const normalizedManualValue = Number(row.selection) === 3
          ? Math.abs(Number(manualValue) || 0)
          : (Number(manualValue) || 0);

        row.itemTotalAmountWithoutTax = normalizedManualValue;
        row.itemTotalAmountWithoutTaxDisplay = this.formatNumberDisplay(normalizedManualValue);
        row.total = normalizedManualValue;
        row.taxAmount = null;
        row.itemTotalAmountAfterDiscount = null;
        row.itemTotalAmountWithTax = null;
        row.itemDiscount = null;
        return;
      }

      const qty = Number(row.quantity) || 0;
      const price = Number(row.price !== undefined && row.price !== null ? row.price : row.unitPrice) || 0;
      const subtotal = qty * price;

      // Legacy/UI fields
      row.total = subtotal;

      // If this row is marked as excluded from totals (notes, fee without amount), set amounts to 0
      if (row.excludeFromTotals) {
        row.itemTotalAmountWithoutTax = null;
        row.itemTotalAmountWithoutTaxDisplay = '';
        row.taxAmount = null;
        return;
      }

      // If it's a discount (isIncreaseItem === false), store negative amount
      const signedSubtotal = row.isIncreaseItem ? subtotal : -Math.abs(subtotal);
      row.itemTotalAmountWithoutTax = signedSubtotal;

      // compute tax amount
      const taxPerc = row.taxPercentage;
      if (String(taxPerc) === 'cttc' || String(taxPerc) === 'other') {
        // if custom, taxAmount should be preserved or computed elsewhere
        // keep existing taxAmount
      } else {
        const perc = Number(taxPerc) || 0;
        row.taxAmount = Math.round((Math.abs(signedSubtotal) * perc) / 100);
        // if discount, tax should be negative
        if (!row.isIncreaseItem) row.taxAmount = -Math.abs(row.taxAmount);
      }

      // DTO base fields
      row.unitPrice = Number(price);
      row.itemTotalAmountWithoutTax = Number(subtotal);
      row.itemTotalAmountWithoutTaxDisplay = this.formatNumberDisplay(Number(subtotal) || 0);

      // compute discount amount: if itemDiscount (monetary) provided use it; otherwise derive from discount% and discount2%
      let itemDiscountAmount = 0;
      const discPercent = Number(row.discount || 0) || 0;
      const discPercent2 = Number(row.discount2 || 0) || 0;
      if (row.itemDiscount !== undefined && row.itemDiscount) {
        itemDiscountAmount = Number(row.itemDiscount) || 0;
      } else if (discPercent || discPercent2) {
        let after = subtotal;
        if (discPercent) after = after * (1 - discPercent / 100);
        if (discPercent2) after = after * (1 - discPercent2 / 100);
        itemDiscountAmount = Math.round((subtotal - after) * 100) / 100;
      }
      row.itemDiscount = Number(itemDiscountAmount || 0);
      const amountAfterDiscount = Math.round((subtotal - itemDiscountAmount) * 100) / 100;
      row.itemTotalAmountAfterDiscount = amountAfterDiscount;

      // Determine tax percentage handling special codes:
      // -2 => not taxed (taxAmount = 0)
      // -1 => not declared (taxAmount = 0)
      // 'cttc', 'other' => no tax (user hasn't entered value yet)
      // numeric >= 0 => percentage
      let rawTax = row.taxPercent !== undefined && row.taxPercent !== null ? row.taxPercent : row.taxPercentage;

      // If selection is CTTC/Khác but user hasn't entered numeric value, taxAmount = 0
      if (String(rawTax) === 'cttc' || String(rawTax) === 'other') {
        if (!row.taxAmountFromBackend) row.taxAmount = 0;
        row.itemTotalAmountWithTax = Math.round(amountAfterDiscount * 100) / 100;
        return; // nothing more to compute until numeric percent provided
      }

      // Parse tax value (handle numeric codes and percentages)
      const parsed = this.getPercentNumber(rawTax);
      const isSpecialNegative = String(rawTax).trim().startsWith('-');
      let taxAmount = 0;

      if (isSpecialNegative) {
        // special codes (-2, -1) => no tax
        taxAmount = 0;
      } else {
        // numeric percentage
        taxAmount = Math.round(amountAfterDiscount * parsed / 100);
      }

      // Store final value in taxPercentage for payload, but preserve empty or special string codes
      if (rawTax === undefined || rawTax === null || String(rawTax).trim() === '') {
        // preserve empty so UI shows placeholder "--Lựa chọn--"
        row.taxPercentage = '';
      } else if (String(rawTax) === 'cttc' || String(rawTax) === 'other') {
        // preserve special string codes
        row.taxPercentage = String(rawTax);
      } else if (String(rawTax).trim().startsWith('-')) {
        // negative special codes like -1, -2 -> keep as numbers
        row.taxPercentage = Number(rawTax);
      } else {
        // numeric percentage
        const num = Number(rawTax);
        row.taxPercentage = Number.isFinite(num) ? num : '';
      }

      if (isSpecialNegative) {
        // Với mã -1/-2 luôn là không tính thuế, không giữ taxAmount âm từ backend
        row.taxAmount = 0;
        row.itemTotalAmountWithTax = Math.round(amountAfterDiscount * 100) / 100;
        return;
      }

      // if taxAmount provided from backend, preserve it (some invoices send totals instead of per-line tax)
      if (!row.taxAmountFromBackend) {
        row.taxAmount = Number(taxAmount);
      }
      row.itemTotalAmountWithTax = Math.round((amountAfterDiscount + taxAmount) * 100) / 100;

    },

    formatCurrency(value) {
      try {
        return new Intl.NumberFormat('vi-VN').format(Number(value) || 0) + ' ₫';
      } catch (e) {
        return value;
      }
    },
    // Format amount based on currency code
    formatCurrencyByCode(value, code) {
      try {
        if (!code || code === 'VND') {
          return new Intl.NumberFormat('vi-VN').format(Number(value) || 0) + ' ₫';
        }
        // For other currencies, show using user's locale and append code
        return new Intl.NumberFormat(undefined, { maximumFractionDigits: 2 }).format(Number(value) || 0) + ' ' + code;
      } catch (e) {
        return value + (code ? (' ' + code) : '');
      }
    },
    // Format number with thousand separator (.)
    formatNumberDisplay(value) {
      const num = Number(value) || 0;
      return new Intl.NumberFormat('de-DE').format(num);
    },

    // Format quantity display supporting up to 2 decimal places without thousand separators
    formatQuantityDisplay(value) {
      if (value === null || value === undefined || value === '') return '';
      const num = Number(value);
      if (!Number.isFinite(num)) return '';
      return Number(num.toFixed(2)).toString();
    },

    // Parse quantity input string supporting decimal comma and dot (max 2 decimal places)
    parseQuantityInput(value) {
      if (value === null || value === undefined) return 0;
      const str = String(value).trim().replace(/,/g, '.');
      const num = parseFloat(str);
      if (!Number.isFinite(num) || num < 0) return 0;
      return Math.round(num * 100) / 100;
    },

    // Parse number string with thousand separator (.) back to number
    parseNumberInput(value) {
      const str = String(value || '').trim();
      const parsed = str.replace(/\./g, ''); // Remove . separators
      return Number(parsed) || 0;
    },
    // Handle quantity input blur/enter
    onQuantityBlur(row) {
      if (!row.allowQuantity) {
        // ensure value is zero when not allowed
        row.quantity = 0;
        row.quantityDisplay = this.formatQuantityDisplay(0);
        this.calculateRow(row);
        return;
      }
      const parsed = this.parseQuantityInput(row.quantityDisplay);
      row.quantity = parsed;
      row.quantityDisplay = this.formatQuantityDisplay(parsed);
      this.calculateRow(row);
    },

    // Handle unit price input blur/enter
    onUnitPriceBlur(row) {
      if (!row.allowUnitPrice) {
        row.unitPrice = 0;
        row.unitPriceDisplay = this.formatNumberDisplay(0);
        this.calculateRow(row);
        this.syncCustomProductDefaults(row);
        return;
      }
      const parsed = this.parseNumberInput(row.unitPriceDisplay);
      row.unitPrice = parsed;
      row.unitPriceDisplay = this.formatNumberDisplay(parsed);
      this.calculateRow(row);
      this.syncCustomProductDefaults(row);
    },
    onTotalAmountBlur(row) {
      if (!row || !row.allowTotalAmount) {
        row.itemTotalAmountWithoutTaxDisplay = '';
        return;
      }

      const parsedTotal = this.parseNumberInput(row.itemTotalAmountWithoutTaxDisplay);
      const safeTotal = Number(parsedTotal) || 0;

      // Chiết khấu: giữ quantity/unitPrice là null, chỉ lưu Thành tiền thủ công
      if (Number(row.selection) === 3) {
        row.quantity = null;
        row.quantityDisplay = '';
        row.unitPrice = null;
        row.unitPriceDisplay = '';
        row.itemTotalAmountWithoutTax = safeTotal;
        row.itemTotalAmountWithoutTaxDisplay = this.formatNumberDisplay(safeTotal);
        this.calculateRow(row);
        return;
      }

      let qty = Number(row.quantity) || 0;
      if (qty <= 0) {
        qty = 1;
        row.quantity = 1;
        row.quantityDisplay = this.formatQuantityDisplay(1);
      }

      // Quy đổi ngược: Thành tiền / Số lượng => Đơn giá
      row.unitPrice = Math.round(safeTotal / qty);
      row.unitPriceDisplay = this.formatNumberDisplay(row.unitPrice);
      this.calculateRow(row);
      this.syncCustomProductDefaults(row);
    },
    addRow() {
      this.items.push(this.createEmptyItem());
      this.recalcAllRows();
    },
    removeRow(index) {
      this.items.splice(index,1);
      this.recalcAllRows();
    },
    buildCreateInvoiceRequest() {
      const draftSource = this.draftSourceRequest || {};
      const draftGeneralInvoiceInfo = draftSource.generalInvoiceInfo || {};
      const draftBuyerInfo = draftSource.buyerInfo || {};
      const draftSummarizeInfo = draftSource.summarizeInfo || {};
      const editingTransactionUuid = this.resolveEditingTransactionUuid();

      // Tính tax breakdown theo từng mức VAT
      const taxMap = {};
      this.items.forEach(item => {
        if (Number(item.selection) === 3) return;
        const taxRate = Number(item.taxPercentage) || 0;
        if (!taxMap[taxRate]) {
          taxMap[taxRate] = { taxRate, totalAmount: 0, totalTaxAmount: 0 };
        }
        taxMap[taxRate].totalAmount += Number(item.itemTotalAmountAfterDiscount || item.itemTotalAmountWithoutTax || 0);
        taxMap[taxRate].totalTaxAmount += Number(item.taxAmount || 0);
      });
      const taxBreakdowns = Object.values(taxMap).map(t => ({
        taxPercentage: t.taxRate,
        taxableAmount: t.totalAmount,
        taxAmount: t.totalTaxAmount
      }));

      // Build CreateInvoiceRequest object
      return {
        generalInvoiceInfo: {
          ...draftGeneralInvoiceInfo,
          invoiceType: draftGeneralInvoiceInfo.invoiceType || 'none',
          templateCode: this.form.templateCode,
          invoiceSeries: this.form.invoiceSeries,
          invoiceIssuedDate: this.form.invoiceIssuedDate,
          currencyCode: this.form.currencyCode || 'VND',
          exchangeRate: Number(this.form.exchangeRate) || 1,
          certificateSerial: draftGeneralInvoiceInfo.certificateSerial || '',
          reservationCode: draftGeneralInvoiceInfo.reservationCode || '',
          paymentStatus: this.form.paymentStatus,
          cusGetInvoiceRight: !this.form.buyerNotGetInvoice,
          transactionUuid: editingTransactionUuid || undefined,
          invoiceNote: this.form.invoiceNote || null
        },
        sellerInfo: draftSource.sellerInfo || undefined,
        buyerInfo: {
          ...draftBuyerInfo,
          buyerName: this.form.buyerName,
          buyerCode: this.form.buyerCode,
          buyerLegalName: this.form.buyerLegalName,
          buyerTaxCode: this.form.buyerTaxCode,
          buyerBudgetCode: this.form.buyerBudgetCode,
          buyerAddressLine: this.form.buyerAddressLine,
          buyerPhoneNumber: this.form.buyerPhoneNumber,
          buyerEmail: this.form.buyerEmail,
          buyerBankName: this.form.buyerBankName,
          buyerBankAccount: this.form.buyerBankAccount,
          buyerIdType: this.form.buyerIdType,
          buyerIdNo: String(this.form.buyerIdNo || ''),
          buyerNotGetInvoice: this.form.buyerNotGetInvoice ? 1 : 0,
          contractNo: this.form.contractNo
        },
        payments: [
          {
            paymentMethod: this.form.paymentMethod,
            paymentMethodName: this.form.paymentMethod === '5'
              ? this.form.paymentMethodName
              : (this.paymentMethodMap[this.form.paymentMethod] || this.form.paymentMethodName)
          }
        ],
        itemInfo: this.items.map((item, idx) => {
          const selection = Number(item.selection) || 1;
          const isNoteItem = selection === 2;
          const isDiscountItem = selection === 3;

          return {
            lineNumber: idx + 1,
            selection,
            itemType: item.itemType,
            itemCode: isNoteItem ? null : item.itemCode,
            itemName: item.itemName,
            unitCode: isNoteItem ? null : item.unitCode,
            unitName: isNoteItem ? null : item.unitName,
            unitPrice: (isNoteItem || isDiscountItem) ? null : (item.unitPrice !== null && item.unitPrice !== undefined ? Number(item.unitPrice) || 0 : null),
            quantity: (isNoteItem || isDiscountItem) ? null : (item.quantity !== null && item.quantity !== undefined ? Number(item.quantity) || 0 : null),
            itemTotalAmountWithoutTax: isNoteItem
              ? null
              : (item.itemTotalAmountWithoutTax !== null && item.itemTotalAmountWithoutTax !== undefined
                ? (isDiscountItem ? Math.abs(Number(item.itemTotalAmountWithoutTax) || 0) : (Number(item.itemTotalAmountWithoutTax) || 0))
                : null),
            taxPercentage: isNoteItem ? null : (item.taxPercentage !== null && item.taxPercentage !== undefined && item.taxPercentage !== '' ? Number(item.taxPercentage) || 0 : null),
            taxAmount: isNoteItem ? null : (item.taxAmount !== null && item.taxAmount !== undefined ? Number(item.taxAmount) || 0 : null),
            itemNote: item.itemNote,
            batchNo: item.batchNo,
            expDate: item.expDate,
            discount: isNoteItem ? null : (item.discount !== null && item.discount !== undefined ? Number(item.discount) || 0 : null),
            discount2: isNoteItem ? null : (item.discount2 !== null && item.discount2 !== undefined ? Number(item.discount2) || 0 : null),
            itemDiscount: isNoteItem ? null : (item.itemDiscount !== null && item.itemDiscount !== undefined ? Number(item.itemDiscount) || 0 : null),
            itemTotalAmountAfterDiscount: isNoteItem ? null : (item.itemTotalAmountAfterDiscount !== null && item.itemTotalAmountAfterDiscount !== undefined ? Number(item.itemTotalAmountAfterDiscount) || 0 : null),
            itemTotalAmountWithTax: isNoteItem ? null : (item.itemTotalAmountWithTax !== null && item.itemTotalAmountWithTax !== undefined ? Number(item.itemTotalAmountWithTax) || 0 : null),
            isIncreaseItem: item.isIncreaseItem !== false
          };
        }),
        taxBreakdowns,
        summarizeInfo: {
          ...draftSummarizeInfo,
          totalAmountWithoutTax: Number(this.subtotal) || 0,
          totalTaxAmount: Number(this.lineTaxTotal) || 0,
          totalAmountWithTax: Number(this.totalAfterTax) || 0,
          totalAmountWithTaxInWords: this.totalInWords,
          isTotalAmountPos: this.totalAfterTax >= 0,
          isTotalTaxAmountPos: this.lineTaxTotal >= 0,
          isTotalAmtWithoutTaxPos: this.subtotal >= 0,
          discountAmount: Number(this.totalInvoiceDiscountAmount) || 0,
          isDiscountAmtPos: this.totalInvoiceDiscountAmount >= 0,
          extraName: this.form.invoiceNote ? 'Ghi chú' : null,
          extraValue: this.form.invoiceNote || null,
          totalAmountAfterDiscount: Number(this.totalAfterTax) || 0
        },
        extAttribute: draftSource.extAttribute || null,
        metadata: draftSource.metadata || null,
        meterReading: draftSource.meterReading || null,
        orderKidCode: this.orderKidCode || draftSource.orderKidCode || '',
        invoicePurpose: this.$props.invoicePurpose,
      };
    },
    buildInvoicePayload(action = 'final') {
      const request = this.buildCreateInvoiceRequest();
      return {
        ...request,
        meta: {
          action
        }
      };
    },
    getInvoiceRequest(payload) {
      return {
        generalInvoiceInfo: payload.generalInvoiceInfo,
        sellerInfo: payload.sellerInfo,
        buyerInfo: payload.buyerInfo,
        payments: payload.payments,
        itemInfo: payload.itemInfo,
        taxBreakdowns: payload.taxBreakdowns,
        summarizeInfo: payload.summarizeInfo,
        extAttribute: payload.extAttribute,
        metadata: payload.metadata,
        meterReading: payload.meterReading,
        orderKidCode: payload.orderKidCode || this.orderKidCode,
        invoicePurpose: this.$props.invoicePurpose,
      };
    },

    emitInvoiceActionSuccess(action, request, response = null) {
      const payload = {
        action,
        request,
        response,
      };

      if (action === 'final') {
        this.$emit('invoice-created', payload);
      }

      this.$emit('invoice-action-success', payload);
    },
    validateDialogForms(includeCustomerForm = true) {
      // normalize customer fields before validating
      try {
        this.normalizeCustomerFields();
      } catch (e) {
        // ignore normalization errors
        console.warn('normalizeCustomerFields failed', e);
      }
      return new Promise((resolve) => {
        const invoiceForm = this.$refs.invoiceForm;
        const customerForm = this.$refs.customerForm;
        let ok = true;

        if (includeCustomerForm && customerForm && customerForm.validate) {
          customerForm.validate((valid) => {
            if (!valid) ok = false;
          });
        }

        if (invoiceForm && invoiceForm.validate) {
          invoiceForm.validate((valid) => {
            if (!valid) ok = false;
          });
        }

        setTimeout(() => resolve(ok), 50);
      });
    },
    // Normalize some customer fields before validation/submission
    normalizeCustomerFields() {
      if (!this.form) return;
      // Normalize buyer name and legal name: collapse multiple spaces and trim
      if (this.form.buyerName !== undefined && this.form.buyerName !== null) {
        this.form.buyerName = String(this.form.buyerName).replace(/\s+/g, ' ').trim();
      }
      if (this.form.buyerLegalName !== undefined && this.form.buyerLegalName !== null) {
        this.form.buyerLegalName = String(this.form.buyerLegalName).replace(/\s+/g, ' ').trim();
      }
      // Normalize address: collapse multiple spaces and trim
      if (this.form.buyerAddressLine !== undefined && this.form.buyerAddressLine !== null) {
        this.form.buyerAddressLine = String(this.form.buyerAddressLine).replace(/\s+/g, ' ').trim();
      }
      // Normalize ID: remove spaces and dashes, then trim
      if (this.form.buyerIdNo !== undefined && this.form.buyerIdNo !== null) {
        this.form.buyerIdNo = String(this.form.buyerIdNo).replace(/[\s-]+/g, '').trim();
      }
      // Normalize paymentMethodName if present
      if (this.form.paymentMethodName !== undefined && this.form.paymentMethodName !== null) {
        this.form.paymentMethodName = String(this.form.paymentMethodName).replace(/\s+/g, ' ').trim();
      }
    },
    hasValidTaxSelection(row) {
      if (!row || Number(row.selection) !== 1) return true;

      const taxValue = row.taxPercentage;
      if (taxValue === undefined || taxValue === null || String(taxValue).trim() === '') {
        return false;
      }

      const taxString = String(taxValue).trim();
      if (taxString === 'other' || taxString === 'cttc') {
        return row.taxPercentageInput !== undefined
          && row.taxPercentageInput !== null
          && String(row.taxPercentageInput).trim() !== '';
      }

      return true;
    },
    hasValidUnitSelection(row) {
      if (!row || Number(row.selection) !== 1) return true;
      return row.unitName !== undefined
        && row.unitName !== null
        && String(row.unitName).trim() !== '';
    },
    validateItems(strict = true) {
      const invalidUnitItem = this.items.findIndex(i => Number(i.selection) === 1 && !this.hasValidUnitSelection(i));
      if (invalidUnitItem !== -1) {
        const row = this.items[invalidUnitItem];
        NotifyMessage.leftCornerNotificationError(`Vui lòng chọn đơn vị tính cho dòng hàng hóa, dịch vụ số ${this.computeVisibleIndex(row) || (invalidUnitItem + 1)}.`);
        return false;
      }

      const invalidTaxItem = this.items.findIndex(i => Number(i.selection) === 1 && !this.hasValidTaxSelection(i));
      if (invalidTaxItem !== -1) {
        const row = this.items[invalidTaxItem];
        NotifyMessage.leftCornerNotificationError(`Vui lòng chọn tiền thuế cho dòng hàng hóa, dịch vụ số ${this.computeVisibleIndex(row) || (invalidTaxItem + 1)}.`);
        return false;
      }

      if (!strict) {
        const hasNegativeValue = this.items.some(i => Number(i.quantity) < 0 || Number(i.unitPrice) < 0);
        if (hasNegativeValue) {
          NotifyMessage.leftCornerNotificationError('Số lượng và đơn giá không được âm.');
          return false;
        }
        return true;
      }

      // const invalidItem = this.items.findIndex(i => !i.itemName || String(i.itemName).trim() === '' || Number(i.quantity) <= 0 || Number(i.unitPrice) < 0);
      // if (invalidItem !== -1) {
      //   NotifyMessage.leftCornerNotificationError('Vui lòng kiểm tra thông tin hàng hóa: tên hàng, số lượng và đơn giá.');
      //   return false;
      // }
      return true;
    },
    handleBack() {
      // Reset form fields to defaults when user goes back
      try {
        this.handleClearInput();
      } catch (e) {
        // ignore
      }
      this.$emit('back');
      this.$emit('dialog-close');
    },
    handleClearInput() {
      this.previewDialogVisible = false;
      this.previewPayloadText = '';
      this.confirmIssueDialogVisible = false;
      this.pendingFinalRequest = null;
      this.confirmDraftDialogVisible = false;
      this.form = this.createDefaultFormState();
      this.items = [this.createEmptyItem()];
      this.productOptions = [];
      this.productMap = {};
      this.draftSourceRequest = null;
      this.$nextTick(() => {
        if (this.$refs.customerForm && this.$refs.customerForm.clearValidate) this.$refs.customerForm.clearValidate();
        if (this.$refs.invoiceForm && this.$refs.invoiceForm.clearValidate) this.$refs.invoiceForm.clearValidate();
      });
      this.$emit('clear-invoice-form');
    },
    async handlePreviewInvoice() {
      console.log(this.orderKidCode)
      await this.submitInvoiceAction('preview');
    },

    async handleConfirmCreateDraftInvoice() {
      this.confirmDraftDialogVisible = false;
      await this.submitInvoiceAction('draft');
    },

    async handleCreateInvoice() {
      const valid = await this.validateDialogForms(true);
      if (!valid) return;
      if (!this.validateItems(true)) return;

      const payload = this.buildInvoicePayload('final');
      this.pendingFinalRequest = this.getInvoiceRequest(payload);
      this.confirmIssueDialogVisible = true;
    },
    async handleSaveServerDraftInvoice() {
      await this.submitInvoiceAction('save');
      this.handleClearInput();
    },
    handleConfirmIssue() {
      this.confirmIssueDialogVisible = false;
      this.handleSubmitFinalInvoice();
      this.handleClearInput();
    },
    getUsbDigitalSignatureConfig() {
      return !!this.getSinvoiceConfigField('usbDigitalSignature', false);
    },

    async handleSubmitFinalInvoice() {
      if (!this.pendingFinalRequest) {
        NotifyMessage.leftCornerNotificationError('Không tìm thấy dữ liệu hóa đơn để phát hành.');
        return;
      }

      this.actionLoading.final = true;
      try {
        const request = this.pendingFinalRequest;
        const useUsbDigitalSignature = this.getUsbDigitalSignatureConfig();
        const response = useUsbDigitalSignature
            ? await ElectronicInvoicesService.createInvoiceUsbToken(request)
            : await ElectronicInvoicesService.createElectronicInvoice(request);

        const normalizedResponse = response && response.data ? response.data : response;
        NotifyMessage.leftCornerNotificationSuccess('Lập hóa đơn thành công');
        this.emitInvoiceActionSuccess('final', request, normalizedResponse);

        this.pendingFinalRequest = null;
        this.$emit('dialog-close');
      } catch (error) {
        const message = error?.response?.data?.message || 'Lập hóa đơn thất bại';
        NotifyMessage.leftCornerNotificationError(message);
      } finally {
        this.actionLoading.final = false;
      }
    },
    async submitInvoiceAction(action) {
      const strictMode = action !== 'draft';
      const valid = await this.validateDialogForms(strictMode);
      if (!valid) return;
      if (!this.validateItems(strictMode)) return;

      const payload = this.buildInvoicePayload(action);
      const request = this.getInvoiceRequest(payload);

      this.actionLoading[action] = true;
      try {
            if (action === 'preview') {
              try {
                const resp = await ElectronicInvoicesService.previewInvoice(request);
                const arrayBuffer = resp && resp.data ? resp.data : resp;
                const blob = new Blob([arrayBuffer], { type: 'application/pdf' });
                if (this.previewPdfUrl) {
                  URL.revokeObjectURL(this.previewPdfUrl);
                  this.previewPdfUrl = null;
                }
                this.previewPdfUrl = URL.createObjectURL(blob);
                this.previewDialogVisible = true;
                this.emitInvoiceActionSuccess(action, request, null);
              } catch (err) {
                console.error('Preview invoice failed', err);
                NotifyMessage.leftCornerNotificationError('Xem trước hóa đơn thất bại')
              }
              return;
            }

        if (action === 'draft') {
          try {
            const resp = await ElectronicInvoicesService.createDraftInvoice(request);
            const ok = resp && resp.data !== undefined ? resp.data : (resp || false);
            if (ok) {
              NotifyMessage.leftCornerNotificationSuccess('Lập hóa đơn nháp thành công');
              this.emitInvoiceActionSuccess(action, request, resp && resp.data ? resp.data : resp);
              this.$emit('dialog-close');
            } else {
              NotifyMessage.leftCornerNotificationError('Lập hóa đơn nháp thất bại');
            }
          } catch (err) {
            console.error('Create draft invoice failed', err);
            NotifyMessage.leftCornerNotificationError('Lập hóa đơn nháp thất bại');
          }
          return;
        }
        if (action === 'save') {
          try {
            const transactionUuid = this.resolveEditingTransactionUuid();
            const resp = transactionUuid
              ? await ElectronicInvoicesService.updateDraftOneKidsInvoice(request, transactionUuid)
              : await ElectronicInvoicesService.createDraftOneKidsInvoice(request);
            const ok = resp && resp.data !== undefined ? resp.data : (resp || false);
            if (ok) {
              NotifyMessage.leftCornerNotificationSuccess('Lưu hóa đơn nháp thành công');
              this.emitInvoiceActionSuccess(action, request, resp && resp.data ? resp.data : resp);
              this.$emit('dialog-close');
            } else {
              NotifyMessage.leftCornerNotificationError('Lưu hóa đơn nháp thất bại');
            }
          } catch (err) {
            console.error('Create draft invoice failed', err);
            NotifyMessage.leftCornerNotificationError('Lưu hóa đơn nháp thất bại');
          }
          return;
        }
        if (action === 'final') return;
        // const response = await ElectronicInvoicesService.createElectronicInvoice(request);
        // const normalizedResponse = response && response.data ? response.data : response;
        // NotifyMessage.leftCornerNotificationSuccess('Lập hóa đơn thành công');
        // this.emitInvoiceActionSuccess(action, request, normalizedResponse);
        // this.$emit('dialog-close');
      } catch (error) {
        const message = error && error.response && error.response.data && error.response.data.message
          ? error.response.data.message
          : (action === 'final' ? 'Lập hóa đơn thất bại' : 'Xử lý hóa đơn thất bại');
        NotifyMessage.leftCornerNotificationError(message);
      } finally {
        this.actionLoading[action] = false;
      }
    },
    handleClose(done) {
      // Reset form fields when dialog is closed via X (before-close)
      try {
        this.handleClearInput();
      } catch (e) {
        // ignore
      }

      // ensure preview is cleaned up (handleClearInput already does this, but keep safe guard)
      this.previewDialogVisible = false;
      if (this.previewPdfUrl) {
        try {
          URL.revokeObjectURL(this.previewPdfUrl);
        } catch (e) {
          // ignore
        }
        this.previewPdfUrl = null;
      }

      this.$emit('dialog-close');
      // call done() if provided by before-close so dialog will close
      if (typeof done === 'function') done();
    },
    handlePreviewDialogClose(done) {
      // revoke URL and close preview dialog
      if (this.previewPdfUrl) {
        URL.revokeObjectURL(this.previewPdfUrl);
        this.previewPdfUrl = null;
      }
      this.previewDialogVisible = false;
      if (typeof done === 'function') done();
    },
    revalidateBuyerIdentityFields() {
      this.$nextTick(() => {
        if (this.$refs.customerForm && this.$refs.customerForm.validateField) {
          this.$refs.customerForm.validateField('buyerName');
          this.$refs.customerForm.validateField('buyerLegalName');
          this.$refs.customerForm.validateField('buyerTaxCode');
        }
      });
    },
    // Validator: require at least one of buyerName or buyerLegalName
    buyerNameOrLegalNameValidator(rule, value, callback) {
      const buyerName = this.form && this.form.buyerName ? String(this.form.buyerName).trim() : '';
      const buyerLegalName = this.form && this.form.buyerLegalName ? String(this.form.buyerLegalName).trim() : '';
      if (!buyerName && !buyerLegalName) {
        return callback(new Error('Vui lòng nhập tên người mua hoặc tên đơn vị'));
      }
      return callback();
    },
    // Validator: require buyerTaxCode when buyerLegalName is provided
    buyerTaxCodeByLegalNameValidator(rule, value, callback) {
      const buyerLegalName = this.form && this.form.buyerLegalName ? String(this.form.buyerLegalName).trim() : '';
      const buyerTaxCode = value !== undefined && value !== null ? String(value).trim() : '';
      if (buyerLegalName && !buyerTaxCode) {
        return callback(new Error('Vui lòng nhập mã số thuế'));
      }
      return callback();
    },
    // Validator: require paymentMethodName only when paymentMethod === '5' (KHAC)
    paymentMethodNameValidator(rule, value, callback) {
      if (String(this.form.paymentMethod) === '5') {
        const v = value !== undefined && value !== null ? String(value).trim() : '';
        if (!v) return callback(new Error('Vui lòng nhập chi tiết hình thức thanh toán'));
      }
      return callback();
    },
    // Validator: require buyerIdNo only when buyerIdType is selected
    buyerIdNoValidator(rule, value, callback) {
      const type = this.form && this.form.buyerIdType ? String(this.form.buyerIdType).trim() : '';
      const v = value !== undefined && value !== null ? String(value).trim() : '';
      if (!type) {
        // no type selected -> no validation required
        return callback();
      }
      if (!v) {
        return callback(new Error('Vui lòng nhập số giấy tờ khi đã chọn loại giấy tờ'));
      }

      // Type-specific validation
      if (type === '1') {
        // CMND: 9 or 12 digits
        if (!/^\d{9}$|^\d{12}$/.test(v)) {
          return callback(new Error('CMND phải là 9 hoặc 12 chữ số'));
        }
      } else if (type === '2') {
        // CCCD: 12 digits
        if (!/^\d{12}$/.test(v)) {
          return callback(new Error('CCCD phải là 12 chữ số'));
        }
      } else if (type === '3') {
        // Hộ chiếu: 6-9 alphanumeric
        if (!/^[a-zA-Z0-9]{6,9}$/.test(v)) {
          return callback(new Error('Hộ chiếu phải gồm 6-9 ký tự chữ hoặc số'));
        }
      }

      return callback();
    },
    // Validator: buyerAddressLine is always required
    buyerAddressValidator(rule, value, callback) {
      const v = value !== undefined && value !== null ? String(value).trim() : '';
      if (!v) return callback(new Error('Vui lòng nhập địa chỉ'));
      if (v.length < 5) return callback(new Error('Địa chỉ phải dài ít nhất 5 ký tự'));
      if (v.length > 500) return callback(new Error('Địa chỉ không được vượt quá 500 ký tự'));
      return callback();
    },
    // Handle tax percentage select change
    onTaxPercentageChange(row) {
      // User đã thay đổi lựa chọn thuế thì luôn tính lại từ FE
      row.taxAmountFromBackend = false;
      // If CTTC/Khác selected, show input field and don't compute yet
      if (String(row.taxPercentage) === 'cttc' || String(row.taxPercentage) === 'other') {
        row.taxPercentageInput = null;
        if (!row.taxAmountFromBackend) row.taxAmount = 0;
        row.itemTotalAmountWithTax = Math.round((row.itemTotalAmountAfterDiscount || row.itemTotalAmountWithoutTax || 0) * 100) / 100;
        this.syncCustomProductDefaults(row);
        return;
      }
      // Numeric/preset selection: compute immediately
      this.calculateRow(row);
      this.syncCustomProductDefaults(row);
    },
    onCustomTaxInputBlur(row) {
      // Called when user finishes editing custom tax text input
      if (row.taxPercentageInput === null || row.taxPercentageInput === undefined || String(row.taxPercentageInput).trim() === '') {
        row.taxPercentage = '';
        if (!row.taxAmountFromBackend) row.taxAmount = 0;
        row.itemTotalAmountWithTax = Math.round((row.itemTotalAmountAfterDiscount || row.itemTotalAmountWithoutTax || 0) * 100) / 100;
        this.syncCustomProductDefaults(row);
        return;
      }
      const cleaned = String(row.taxPercentageInput).replace('%','').trim();
      const num = Number(cleaned);
      if (Number.isFinite(num)) {
        row.taxPercentage = num;
      }
      this.calculateRow(row);
      this.syncCustomProductDefaults(row);
    },
  }
};


</script>

<style lang="scss" scoped>

.invoice-page{
  padding:20px;
  background:#f5f7fa;
}

.card-header{
  font-weight:600;
  color:#d9001b;
}

.box-card{
  margin-bottom:20px;
}

.mt20{
  margin-top:20px;
}

.add-row{
  margin-top:10px;
  text-align:right;
}

.invoice-total {
  margin-top: 30px;
  width: 600px;
  margin-left: auto;
  font-size: 16px;
}

.invoice-total .row {
  display: flex;
  align-items: center;
  position: relative;
  padding: 6px 0;
}

/* label bên trái */
.invoice-total .row span {
  white-space: nowrap;
  background: #fff;
  padding-right: 8px;
  z-index: 1;
}

/* value bên phải */
.invoice-total .row strong,
.invoice-total .row em {
  white-space: nowrap;
  margin-left: auto;
  background: #fff;
  padding-left: 8px;
  z-index: 1;
}

/* tạo đường chấm ở giữa */
.invoice-total .row::before {
  content: "";
  position: absolute;
  left: 0;
  right: 0;
  top: 50%;
  border-bottom: 1px dotted #999;
  z-index: 0;
}

/* dòng tổng tiền nổi bật */
.invoice-total .row.total strong {
  font-weight: bold;
}

/* dòng chữ */
.invoice-total .row.words em {
  font-style: italic;
}

.preview-json{
  margin:0;
   overflow:auto;
   padding:16px;
   background:#f5f7fa;
   border-radius:4px;
   white-space:pre-wrap;
   word-break:break-word;
}

.preview-pdf-wrapper{
  width:100%;
}

.invoice-detail-header {
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 12px;
}

/* Phần nội dung */
.product-option-wrap {
  line-height: 1.35;
  padding: 2px 0;
}

.product-option-title {
  font-weight: 600;
  color: #303133;
  font-size: 14px;
  margin-bottom: 2px;
}

.product-option-meta {
  font-size: 12px;
  color: #909399;
}

/* Phần chính của option - cân bằng giữa thoáng và không quá dài */
.el-select-dropdown__item {
  max-width: 600px;
  height: auto !important;
  min-height: 54px !important;     /* Chiều cao tối thiểu */
  padding: 8px 16px !important;    /* Giảm padding ngang một chút cho gọn */
  line-height: 1.4 !important;
  white-space: normal !important;
  word-break: break-word;
  overflow: hidden;                /* Ngăn nội dung tràn ra ngoài */
  display: -webkit-box;
  -webkit-box-orient: vertical;
  box-sizing: border-box;
}
/* Thêm đường phân cách nhẹ */
.el-select-dropdown__item:not(:last-child) {
  border-bottom: 1px solid #f0f0f0;
}
.preview-pdf-iframe{
  width:100%;
  min-height:calc(100vh - 140px);
  border:none;
  display:block;
}

/* Bỏ giới hạn chiều cao body của dialog xem trước */
::v-deep .preview-dialog-no-limit .el-dialog__body{
  max-height:none !important;
  overflow:visible !important;
}
.product-cell{
  display:flex;
  flex-direction:column;
}


/* Make table headers blue with white text */
::v-deep .el-table th,
::v-deep .el-table__header th,
::v-deep .el-table__header-wrapper th {
  background-color: #1f78d1 !important; /* blue */
  color: #fff !important;
  font-weight: 600 !important;
}

::v-deep .el-table__header-wrapper .cell {
  color: #fff !important;
}
.tax-cell{
  display:flex;
  align-items:center;
  gap:6px;
}

.tax-equal{
  font-weight:bold;
  color:#666;
}

/* Make required field asterisk red */
::v-deep .el-form-item.is-required > .el-form-item__label::after {
  color: #d9001b;
}

.required-asterisk{
  color: #d9001b;
  font-weight: 600;
  margin-left:2px;
}

.invoice-warning{
  margin-top:8px;
  color: #d9001b; /* red */
  font-weight: 700;
  background: #fff6f6;
  padding: 8px 12px;
  border-left: 4px solid #d9001b;
  border-radius: 4px;
  display: block;
  line-height: 1.45; /* ensure lines don't overlap */
  white-space: normal;
  overflow: visible;
}
.invoice-warning > div{
  display: block;
  margin-bottom: 4px;
}
.invoice-warning > div:last-child{
  margin-bottom: 0;
}
/* Ensure the top two cards have equal height */
.top-row-flex {
  display: flex;
}

/* Make columns expand and cards fill the column height */
::v-deep .top-row-flex > .el-col {
  display: flex;
  flex-direction: column;
  /* allow flex children to shrink to avoid horizontal overflow */
  min-width: 0;
}

::v-deep .top-row-flex .el-card {
  flex: 1 1 auto;
  display: flex;
  flex-direction: column;
  /* ensure card can shrink inside flex container */
  min-width: 0;
}

/* Make form inside card scroll if it overflows */
::v-deep .top-row-flex .el-card .el-form {
  flex: 1 1 auto;
  overflow-y: auto;
  overflow-x: hidden; /* hide horizontal scrollbar */
  box-sizing: border-box;
  padding-bottom: 10px;
}

/* ensure form rows and items don't force horizontal overflow */
::v-deep .top-row-flex .el-form .el-row,
::v-deep .top-row-flex .el-form .el-form-item {
  min-width: 0;
}

/* Ensure specific long labels stay on a single line */
  ::v-deep .single-line-label > .el-form-item__label {
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
  padding-right: 8px;
}

/* Styling for the shortened visible label to look nicer */
::v-deep .single-line-label .short-label {
  font-size: 13px;
  color: rgba(0,0,0,0.65);
  cursor: default;
  display: inline-block;
  vertical-align: middle;
  font-weight: 600;
}

::v-deep .single-line-label .info-icon {
  font-size: 11px;
  color: #909399; /* element-ui text secondary */
  margin-left: 4px;
  vertical-align: middle;
}

/* right-align numeric inputs in table */
::v-deep .numeric-input .el-input__inner {
  text-align: right;
}

/* center quantity input values */
::v-deep .quantity-input .el-input__inner {
  text-align: center;
}

</style>
